export const data =[
  {
    "Title": "Action Comics",
    "Issue #": 22,
    "Condition": "F/G",
    "Website Notes": 1940,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1100,
    "": "30th century"
  },
  {
    "Title": "Action Comics",
    "Issue #": 173,
    "Condition": "CGC 5.0",
    "Website Notes": "Robot Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "clink"
  },
  {
    "Title": "Action Comics",
    "Issue #": 194,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Dahlgren"
  },
  {
    "Title": "Action Comics",
    "Issue #": 244,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Action Comics",
    "Issue #": 257,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Rapid City"
  },
  {
    "Title": "Action Comics",
    "Issue #": 258,
    "Condition": "FN",
    "Website Notes": "Supergirl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Action Comics",
    "Issue #": 259,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Rapid City"
  },
  {
    "Title": "Action Comics",
    "Issue #": 263,
    "Condition": "F/VF",
    "Website Notes": "Origin Bizarro World",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Action Comics",
    "Issue #": 267,
    "Condition": "FN",
    "Website Notes": "3rd App Legion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "Dahlgren"
  },
  {
    "Title": "Action Comics",
    "Issue #": 273,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Action Comics",
    "Issue #": 285,
    "Condition": "FN+",
    "Website Notes": "12th Legion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Dahlgren"
  },
  {
    "Title": "Action Comics",
    "Issue #": 285,
    "Condition": "VG/F",
    "Website Notes": "12th Legion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Nick"
  },
  {
    "Title": "Action Comics",
    "Issue #": 289,
    "Condition": "FN+",
    "Website Notes": "16th Legion",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Action Comics",
    "Issue #": 293,
    "Condition": "VG-",
    "Website Notes": "Superhorse",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Action Comics",
    "Issue #": 340,
    "Condition": "F/VF",
    "Website Notes": "Parasite Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Action Comics",
    "Issue #": 340,
    "Condition": "CBCS 9.2",
    "Website Notes": "Parasite Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 390,
    "": ""
  },
  {
    "Title": "Action Comics",
    "Issue #": 346,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Action Comics",
    "Issue #": 379,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Action Comics",
    "Issue #": 385,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Action Comics",
    "Issue #": 389,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Action Comics",
    "Issue #": 390,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Action Comics",
    "Issue #": 487,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Action Comics",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "1988 Reprint",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 100,
    "Condition": "CGC 4.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 245,
    "": "Matt"
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 205,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 209,
    "Condition": "FA",
    "Website Notes": "CFO",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 220,
    "Condition": "VG",
    "Website Notes": "Krypto C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Dahlgren"
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 230,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 232,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 251,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 256,
    "Condition": "VG",
    "Website Notes": "Origin Green Arrow",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 260,
    "Condition": "CGC 7.0",
    "Website Notes": "Origin Aquaman",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 600,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 260,
    "Condition": "CGC 6.0",
    "Website Notes": "Origin Aquaman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 455,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 266,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 267,
    "Condition": "FN+",
    "Website Notes": "2nd Lgion App",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Rapid City"
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 268,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Rapid City"
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 271,
    "Condition": "VG",
    "Website Notes": "Origin Lex Luthor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Dahlgren"
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 292,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 294,
    "Condition": "FN",
    "Website Notes": "JFK M Monroe Bizzaro",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 295,
    "Condition": "VG",
    "Website Notes": "1st Bizarro Titano",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 296,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 298,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 300,
    "Condition": "VG",
    "Website Notes": "Legion Begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 301,
    "Condition": "G+",
    "Website Notes": "Origin Bouncing Boy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 311,
    "Condition": "FN+",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 313,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 314,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 315,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 316,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 317,
    "Condition": "VG",
    "Website Notes": "1st Dream Girl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 317,
    "Condition": "CGC 7.5",
    "Website Notes": "1st Dream Girl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 318,
    "Condition": "F/VF",
    "Website Notes": "Time Trapper",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 319,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 319,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 320,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 321,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 322,
    "Condition": "F/VF",
    "Website Notes": "Super Pets",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 323,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 324,
    "Condition": "FN",
    "Website Notes": "1st Duplcate Boy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 325,
    "Condition": "F/VF",
    "Website Notes": "Luther c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 326,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 327,
    "Condition": "F/VF",
    "Website Notes": "1st Timberwolf",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 329,
    "Condition": "F/VF",
    "Website Notes": "1st Bizarro Legionairres",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 330,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 331,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 332,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 333,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 334,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 335,
    "Condition": "VF",
    "Website Notes": "1st Starfinger",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 336,
    "Condition": "F/VF",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 336,
    "Condition": "FN+",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 337,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 339,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 340,
    "Condition": "VF",
    "Website Notes": "1st Computo",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 341,
    "Condition": "VF",
    "Website Notes": "1st Duo Damsel",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 342,
    "Condition": "F/VF",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 346,
    "Condition": "VG/F",
    "Website Notes": "1st Karate Kid",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ron"
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 347,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 350,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 351,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 354,
    "Condition": "FN+",
    "Website Notes": "Superman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 355,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 375,
    "Condition": "F/VF",
    "Website Notes": "1st Quantum Queen",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 376,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 377,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 381,
    "Condition": "VG/F",
    "Website Notes": "1st Solo Supergirl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 381,
    "Condition": "VG",
    "Website Notes": "1st Solo Supergirl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 393,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 403,
    "Condition": "VF/NM",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 425,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 428,
    "Condition": "VF/NM",
    "Website Notes": "1st Black Orchid",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 428,
    "Condition": "VF",
    "Website Notes": "1st Black Orchid",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 431,
    "Condition": "VF",
    "Website Notes": "Spectre begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 431,
    "Condition": "FN",
    "Website Notes": "Spectre begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Bednarz"
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 432,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 432,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Bednarz"
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 433,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 434,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 435,
    "Condition": "VF/NM",
    "Website Notes": "pence stamp",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 435,
    "Condition": "VF/NM",
    "Website Notes": "Aquaman Begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 437,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 438,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 439,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 440,
    "Condition": "NM-",
    "Website Notes": "Spectre Origin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 19,
    "": "Bednarz"
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 459,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 460,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Adventure Comics",
    "Issue #": 465,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Adventures of Bob Hope",
    "Issue #": 46,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Rapid City"
  },
  {
    "Title": "Adventures of Bob Hope",
    "Issue #": 90,
    "Condition": "VG",
    "Website Notes": "Robot Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Adventures of Bob Hope",
    "Issue #": 97,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Adventures of Bob Hope",
    "Issue #": 107,
    "Condition": "VG/F",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Adventures of Bob Hope",
    "Issue #": 109,
    "Condition": "FN+",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "BCC"
  },
  {
    "Title": "Adventures of Jerry Lewis",
    "Issue #": 101,
    "Condition": "FN",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Adventures of Jerry Lewis",
    "Issue #": 101,
    "Condition": "VG/F",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Adventures of Jerry Lewis",
    "Issue #": 102,
    "Condition": "VG+",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans"
  },
  {
    "Title": "Adventures of Jerry Lewis",
    "Issue #": 105,
    "Condition": "G",
    "Website Notes": "piece out int",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Adventures of Jerry Lewis",
    "Issue #": 105,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Adventures of Jerry Lewis",
    "Issue #": 107,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Adventures of Jerry Lewis",
    "Issue #": 109,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Adventures of Rex the Wonder Dog",
    "Issue #": 17,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Roanoke"
  },
  {
    "Title": "Adventures of Rex the Wonder Dog",
    "Issue #": 29,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Adventures of Rex the Wonder Dog",
    "Issue #": 29,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventures of Rex the Wonder Dog",
    "Issue #": 32,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "GA Collectibles"
  },
  {
    "Title": "Adventures of Rex the Wonder Dog",
    "Issue #": 32,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Roanoke"
  },
  {
    "Title": "Adventures of Rex the Wonder Dog",
    "Issue #": 41,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Adventures of Rex the Wonder Dog",
    "Issue #": 44,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Adventures of Rex the Wonder Dog",
    "Issue #": 45,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "GA Collectibles"
  },
  {
    "Title": "Adventures of Rex the Wonder Dog",
    "Issue #": 45,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "All American Comics",
    "Issue #": 16,
    "Condition": "P",
    "Website Notes": "Cvrless 1st GL",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5800,
    "": "Hello Comics"
  },
  {
    "Title": "All American Men of War",
    "Issue #": "127(#1)",
    "Condition": "CGC 4.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": "128(#2)",
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "PBA"
  },
  {
    "Title": "All American Men of War",
    "Issue #": 5,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "TTreasures"
  },
  {
    "Title": "All American Men of War",
    "Issue #": 7,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 44,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 8,
    "Condition": "G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 13,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "TTReasures"
  },
  {
    "Title": "All American Men of War",
    "Issue #": 14,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 32,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 15,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 32,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 17,
    "Condition": "VG",
    "Website Notes": "1st Frogman sty",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 27,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 31,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 32,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 35,
    "Condition": "VG/F",
    "Website Notes": "Classic Grey Tone Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 47,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "TTreasures"
  },
  {
    "Title": "All American Men of War",
    "Issue #": 57,
    "Condition": "FN-",
    "Website Notes": "Easy Co C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "TTreasures"
  },
  {
    "Title": "All American Men of War",
    "Issue #": 65,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 69,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 70,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 73,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 74,
    "Condition": "FN-",
    "Website Notes": "1st Minute Commandos",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 74,
    "Condition": "VG-",
    "Website Notes": "1st Minute Commandos",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 75,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 77,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 82,
    "Condition": "VG",
    "Website Notes": "1st Johnny Cloud",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 83,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 88,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 94,
    "Condition": "F/VF",
    "Website Notes": "Classic Heath Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 94,
    "Condition": "FN+",
    "Website Notes": "Classic Heath Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "TTReasures"
  },
  {
    "Title": "All American Men of War",
    "Issue #": 94,
    "Condition": "VG",
    "Website Notes": "Classic Heath Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "All American Men of War",
    "Issue #": 101,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "All American Western",
    "Issue #": 124,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "All American Western",
    "Issue #": 125,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "All Out War",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "All Star Comics",
    "Issue #": 21,
    "Condition": "CGC 3.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 335,
    "": "PBA"
  },
  {
    "Title": "All Star Comics",
    "Issue #": 55,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "Gilligans"
  },
  {
    "Title": "All Star Comics",
    "Issue #": 58,
    "Condition": "F/VF",
    "Website Notes": "1st Power Girl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Ron"
  },
  {
    "Title": "All Star Comics",
    "Issue #": 58,
    "Condition": "VG-",
    "Website Notes": "1st Power Girl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "All Star Comics",
    "Issue #": 61,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "All Star Comics",
    "Issue #": 61,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "All Star Comics",
    "Issue #": 64,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 16,
    "": ""
  },
  {
    "Title": "All Star Western",
    "Issue #": 73,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "All Star Western",
    "Issue #": 84,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "All Star Western",
    "Issue #": 97,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "All Star Western",
    "Issue #": 110,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Rapid City"
  },
  {
    "Title": "All Star Western (1971)",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 21,
    "": ""
  },
  {
    "Title": "All Star Western (1971)",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "All Star Western (1971)",
    "Issue #": 7,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "All Star Western (1971)",
    "Issue #": 10,
    "Condition": "FN-",
    "Website Notes": "1st Jonah Hex",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": ""
  },
  {
    "Title": "Anthro",
    "Issue #": 6,
    "Condition": "FN",
    "Website Notes": "Wood Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Aquaman",
    "Issue #": 1,
    "Condition": "CGC 7.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 775,
    "": "CConnect"
  },
  {
    "Title": "Aquaman",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "gilligans"
  },
  {
    "Title": "Aquaman",
    "Issue #": 6,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Aquaman",
    "Issue #": 11,
    "Condition": "VG+",
    "Website Notes": "1st Mera",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Aquaman",
    "Issue #": 18,
    "Condition": "VG/F",
    "Website Notes": "Wedding Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Aquaman",
    "Issue #": 29,
    "Condition": "FN",
    "Website Notes": "1st Ocean Master",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 190,
    "": ""
  },
  {
    "Title": "Aquaman",
    "Issue #": 29,
    "Condition": "VG/F",
    "Website Notes": "1st Ocean Master",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": ""
  },
  {
    "Title": "Aquaman",
    "Issue #": 29,
    "Condition": "VG",
    "Website Notes": "1st Ocean Master",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Aquaman",
    "Issue #": 35,
    "Condition": "G/VG",
    "Website Notes": "1st Black Manta",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Vince"
  },
  {
    "Title": "Aquaman",
    "Issue #": 37,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Aquaman",
    "Issue #": 43,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Aquaman",
    "Issue #": 45,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Aquaman",
    "Issue #": 50,
    "Condition": "VF",
    "Website Notes": "Deadman Adams",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 23,
    "": ""
  },
  {
    "Title": "Aquaman",
    "Issue #": 52,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Aquaman",
    "Issue #": 52,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 23,
    "": ""
  },
  {
    "Title": "Aquaman",
    "Issue #": 52,
    "Condition": "VF+",
    "Website Notes": "Deadman Adams",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 23,
    "": ""
  },
  {
    "Title": "Aquaman",
    "Issue #": 56,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Vince"
  },
  {
    "Title": "Aquaman",
    "Issue #": 63,
    "Condition": "VF/NM",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Vince"
  },
  {
    "Title": "Arak",
    "Issue #": 12,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 165,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 2,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 2,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 3,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 5,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 5,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 11,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 11,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 12,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 13,
    "Condition": "F/VF",
    "Website Notes": "Chronos c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 15,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 18,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 19,
    "Condition": "VF-",
    "Website Notes": "2nd Zatanna",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 20,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 21,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 23,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 24,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 26,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 29,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 36,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 41,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Atom",
    "Issue #": 42,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Atom",
    "Issue #": 45,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Batgirl Special",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 1988,
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 22,
    "Condition": "VG+",
    "Website Notes": "1st Alfred C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 37,
    "Condition": "F/VF(A)",
    "Website Notes": "Missing CF",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 800,
    "": "Dahlgren"
  },
  {
    "Title": "Batman",
    "Issue #": 38,
    "Condition": "CGC 6.0",
    "Website Notes": "Penguin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1200,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 43,
    "Condition": "CGC 7.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 700,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 48,
    "Condition": "G+",
    "Website Notes": "Canadian Edition",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 59,
    "Condition": "CGC 4.0",
    "Website Notes": "1st Deadshot",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1600,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 59,
    "Condition": "VG",
    "Website Notes": "1st Deadshot",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1050,
    "": "Gilligans"
  },
  {
    "Title": "Batman",
    "Issue #": 59,
    "Condition": "P",
    "Website Notes": "No Front Cvr O/W FN",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "Dahlgren"
  },
  {
    "Title": "Batman",
    "Issue #": 63,
    "Condition": "CGC 5.5",
    "Website Notes": "1st Killer Moth",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 800,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 66,
    "Condition": "CGC 5.5",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 900,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 66,
    "Condition": "VG",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 73,
    "Condition": "CGC 5.0",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1200,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 83,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 87,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 86,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 87,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 88,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 127,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 90,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 127,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 95,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 100,
    "Condition": "VG",
    "Website Notes": "Anniversary Iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 102,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 103,
    "Condition": "GD",
    "Website Notes": "1st SA Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 106,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 107,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 108,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 109,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 110,
    "Condition": "VG/F",
    "Website Notes": "Joker sty",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 135,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 111,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 111,
    "Condition": "G-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 113,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 117,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 100,
    "": "todd"
  },
  {
    "Title": "Batman",
    "Issue #": 119,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 120,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 123,
    "Condition": "GD",
    "Website Notes": "Joker Sty",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 124,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 125,
    "Condition": "P",
    "Website Notes": "CFO Out",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 128,
    "Condition": "VG/F",
    "Website Notes": "Batwoman Cameo",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 129,
    "Condition": "VG",
    "Website Notes": "Batwoman C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 129,
    "Condition": "VG+",
    "Website Notes": "Batwoman C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 129,
    "Condition": "GD",
    "Website Notes": "Batwoman C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 130,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 131,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 132,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 132,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 50,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 133,
    "Condition": "VG/F",
    "Website Notes": "BatMite/Batwoman",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 133,
    "Condition": "G+",
    "Website Notes": "1st Kite Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 134,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 134,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 135,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 136,
    "Condition": "CBCS 8.5",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 360,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 136,
    "Condition": "G/VG",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "Bedarz"
  },
  {
    "Title": "Batman",
    "Issue #": 137,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Bedarz"
  },
  {
    "Title": "Batman",
    "Issue #": 139,
    "Condition": "VG+",
    "Website Notes": "1st Bat-Girl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "Bedarz"
  },
  {
    "Title": "Batman",
    "Issue #": 139,
    "Condition": "VG",
    "Website Notes": "1st Bat-Girl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 140,
    "Condition": "VG",
    "Website Notes": "Joker Story",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Bedarz"
  },
  {
    "Title": "Batman",
    "Issue #": 141,
    "Condition": "VG",
    "Website Notes": "2nd Bat-Girl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Bedarz"
  },
  {
    "Title": "Batman",
    "Issue #": 142,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 55,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 142,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 143,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 143,
    "Condition": "G+",
    "Website Notes": "Last .10 issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 144,
    "Condition": "FN+",
    "Website Notes": "Joker Story",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 144,
    "Condition": "GD",
    "Website Notes": "Joker Story",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 145,
    "Condition": "P",
    "Website Notes": "CFO",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 146,
    "Condition": "VG",
    "Website Notes": "Bat-Mite",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 147,
    "Condition": "CGC 8.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "Tommy"
  },
  {
    "Title": "Batman",
    "Issue #": 147,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 148,
    "Condition": "GD",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 149,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 149,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 150,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 150,
    "Condition": "F/G",
    "Website Notes": "Large Int Cpn out",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 151,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 151,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Bedarz"
  },
  {
    "Title": "Batman",
    "Issue #": 152,
    "Condition": "VG/F",
    "Website Notes": "Joker Story",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 152,
    "Condition": "GD",
    "Website Notes": "Joker Story",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 153,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 154,
    "Condition": "GD",
    "Website Notes": "Detached Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 155,
    "Condition": "CGC 7.0",
    "Website Notes": "1st SA Penguin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 680,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 155,
    "Condition": "VG/F",
    "Website Notes": "1st SA Penguin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 156,
    "Condition": "VG/F",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 156,
    "Condition": "VG-",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 157,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 157,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 158,
    "Condition": "VG",
    "Website Notes": "Bat-Hound C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 159,
    "Condition": "FN+",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 159,
    "Condition": "FN",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 159,
    "Condition": "VG/F",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 75,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 159,
    "Condition": "F/G",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 160,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 161,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 161,
    "Condition": "G/VG",
    "Website Notes": "Bat-Mite C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 162,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 163,
    "Condition": "VG+",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Poon"
  },
  {
    "Title": "Batman",
    "Issue #": 163,
    "Condition": "VG/F",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 164,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 165,
    "Condition": "G/VG",
    "Website Notes": "Tape on lower spine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 166,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 167,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 168,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Nick"
  },
  {
    "Title": "Batman",
    "Issue #": 168,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 169,
    "Condition": "CGC 9.0",
    "Website Notes": "Penguin C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 220,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 169,
    "Condition": "G/VG",
    "Website Notes": "Penguin C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 170,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Nick"
  },
  {
    "Title": "Batman",
    "Issue #": 170,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Nick"
  },
  {
    "Title": "Batman",
    "Issue #": 170,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 171,
    "Condition": "VG",
    "Website Notes": "1st SA Riddler",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 550,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 171,
    "Condition": "VG-",
    "Website Notes": "1st SA Riddler",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 172,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Nick"
  },
  {
    "Title": "Batman",
    "Issue #": 172,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 173,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 174,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 175,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 176,
    "Condition": "CGC 7.0",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Nick"
  },
  {
    "Title": "Batman",
    "Issue #": 177,
    "Condition": "CGC 8.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "Nick"
  },
  {
    "Title": "Batman",
    "Issue #": 177,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 178,
    "Condition": "CGC 7.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Nick"
  },
  {
    "Title": "Batman",
    "Issue #": 178,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 179,
    "Condition": "VG/F",
    "Website Notes": "2nd SA Riddler",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 179,
    "Condition": "GD",
    "Website Notes": "2nd SA Riddler",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 180,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 181,
    "Condition": "CGC 7.5",
    "Website Notes": "1st Poison Ivy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2400,
    "": "Comiclink"
  },
  {
    "Title": "Batman",
    "Issue #": 181,
    "Condition": "CGC 6.0",
    "Website Notes": "1st Poison Ivy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1200,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 181,
    "Condition": "VG",
    "Website Notes": "1st Poison Ivy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 181,
    "Condition": "VG-",
    "Website Notes": "1st Poison Ivy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 181,
    "Condition": "G/VG",
    "Website Notes": "1st Poison Ivy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "Kent ref"
  },
  {
    "Title": "Batman",
    "Issue #": 181,
    "Condition": "FA",
    "Website Notes": "Missing poster",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 182,
    "Condition": "VF+",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 182,
    "Condition": "VG",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 183,
    "Condition": "VF-",
    "Website Notes": "2nd Poison Ivy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Joe"
  },
  {
    "Title": "Batman",
    "Issue #": 183,
    "Condition": "F/VF",
    "Website Notes": "Pence Stamp",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 183,
    "Condition": "VG/F",
    "Website Notes": "2nd Poison Ivy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 183,
    "Condition": "G/VG",
    "Website Notes": "2nd Poison Ivy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 184,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 186,
    "Condition": "VG/F",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 189,
    "Condition": "FN-",
    "Website Notes": "1st SA Scarecrow",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 225,
    "": "Roanoke"
  },
  {
    "Title": "Batman",
    "Issue #": 189,
    "Condition": "VG/F",
    "Website Notes": "1st SA Scarecrow",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 180,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 189,
    "Condition": "G/VG",
    "Website Notes": "1st SA Scarecrow",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 150,
    "": "Mark"
  },
  {
    "Title": "Batman",
    "Issue #": 190,
    "Condition": "VG+",
    "Website Notes": "Penguin C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Ann Arbor"
  },
  {
    "Title": "Batman",
    "Issue #": 193,
    "Condition": "VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "TTreasures"
  },
  {
    "Title": "Batman",
    "Issue #": 194,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 196,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 196,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 197,
    "Condition": "CGC 8.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 210,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 197,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 178,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 197,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 197,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 200,
    "Condition": "F/VF",
    "Website Notes": "Anniversary Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 200,
    "Condition": "FN",
    "Website Notes": "Anniversary Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Joe"
  },
  {
    "Title": "Batman",
    "Issue #": 200,
    "Condition": "VG/F",
    "Website Notes": "Anniversary Issue",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "Nick"
  },
  {
    "Title": "Batman",
    "Issue #": 203,
    "Condition": "G/VG",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1,
    "": "Frederick"
  },
  {
    "Title": "Batman",
    "Issue #": 205,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "gilligans"
  },
  {
    "Title": "Batman",
    "Issue #": 209,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 210,
    "Condition": "CGC 9.0",
    "Website Notes": "Catwoman C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Holder"
  },
  {
    "Title": "Batman",
    "Issue #": 210,
    "Condition": "VG/F",
    "Website Notes": "Catwoman C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 218,
    "Condition": "VF+",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 222,
    "Condition": "CBCS 7.0",
    "Website Notes": "Beatles",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 260,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 222,
    "Condition": "CGC 7.0",
    "Website Notes": "Beatles",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 285,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 222,
    "Condition": "VG/F",
    "Website Notes": "Beatles",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Nick"
  },
  {
    "Title": "Batman",
    "Issue #": 226,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 227,
    "Condition": "VG-",
    "Website Notes": "CPN Clip",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Mark"
  },
  {
    "Title": "Batman",
    "Issue #": 229,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "TTreasures"
  },
  {
    "Title": "Batman",
    "Issue #": 230,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Kent ref"
  },
  {
    "Title": "Batman",
    "Issue #": 231,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Kent ref"
  },
  {
    "Title": "Batman",
    "Issue #": 232,
    "Condition": "VF/VF+",
    "Website Notes": "Adams Sig",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 360,
    "": "Todd"
  },
  {
    "Title": "Batman",
    "Issue #": 232,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 275,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 232,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 275,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 233,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Kent ref"
  },
  {
    "Title": "Batman",
    "Issue #": 234,
    "Condition": "F/VF",
    "Website Notes": "1st SA Two Face Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Keith"
  },
  {
    "Title": "Batman",
    "Issue #": 234,
    "Condition": "FN+",
    "Website Notes": "1st SA Two Face Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "Kent ref"
  },
  {
    "Title": "Batman",
    "Issue #": 235,
    "Condition": "VF",
    "Website Notes": "Talia Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent ref"
  },
  {
    "Title": "Batman",
    "Issue #": 237,
    "Condition": "CGC 8.5",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 145,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 237,
    "Condition": "G/VG",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 239,
    "Condition": "VF/NM",
    "Website Notes": "Christmas Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "TTreasures"
  },
  {
    "Title": "Batman",
    "Issue #": 239,
    "Condition": "VG/F",
    "Website Notes": "Christmas Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Kent ref"
  },
  {
    "Title": "Batman",
    "Issue #": 243,
    "Condition": "VF/NM",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 244,
    "Condition": "CGC 9.2",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 180,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 244,
    "Condition": "VF+",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Trade Dave"
  },
  {
    "Title": "Batman",
    "Issue #": 245,
    "Condition": "VF",
    "Website Notes": "Classic Adams Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Todd"
  },
  {
    "Title": "Batman",
    "Issue #": 251,
    "Condition": "CGC 8.0",
    "Website Notes": "Adams Joker Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 600,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 251,
    "Condition": "CGC 7.0",
    "Website Notes": "Adams Joker Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 620,
    "": "comiclink"
  },
  {
    "Title": "Batman",
    "Issue #": 251,
    "Condition": "CGC 4.5",
    "Website Notes": "Adams Joker Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 320,
    "": "comiclink"
  },
  {
    "Title": "Batman",
    "Issue #": 251,
    "Condition": "VG+",
    "Website Notes": "Adams Joker Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 253,
    "Condition": "FN",
    "Website Notes": "Shadow C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Batman",
    "Issue #": 253,
    "Condition": "VG/F",
    "Website Notes": "Shadow C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 254,
    "Condition": "VF+",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 255,
    "Condition": "F/VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 257,
    "Condition": "F/VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 258,
    "Condition": "VG/F",
    "Website Notes": "1st Arkham",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 259,
    "Condition": "F/VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 260,
    "Condition": "VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "Joker C/S",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 260,
    "Condition": "F/VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "Joker C/S",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 262,
    "Condition": "F/VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 277,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 296,
    "Condition": "NM",
    "Website Notes": "Scarecrow C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "Holder"
  },
  {
    "Title": "Batman",
    "Issue #": 324,
    "Condition": "VF+",
    "Website Notes": "Catwoman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 325,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 353,
    "Condition": "VF",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 353,
    "Condition": "F/VF",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 357,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "clink"
  },
  {
    "Title": "Batman",
    "Issue #": 386,
    "Condition": "NM-",
    "Website Notes": "1st Black Mask",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 402,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 428,
    "Condition": "F/VF",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 460,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 461,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 488,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 492,
    "Condition": "NM",
    "Website Notes": "Breyfogle Auto w/COA",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Bednarz"
  },
  {
    "Title": "Batman",
    "Issue #": 494,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 497,
    "Condition": "NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman",
    "Issue #": 608,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Cutler"
  },
  {
    "Title": "Batman",
    "Issue #": 609,
    "Condition": "NM",
    "Website Notes": "1st Hush",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": "Cutler"
  },
  {
    "Title": "Batman",
    "Issue #": 612,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Cutler"
  },
  {
    "Title": "Batman",
    "Issue #": 612,
    "Condition": "NM",
    "Website Notes": "Superman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Cutler"
  },
  {
    "Title": "Batman Annual",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Batman Annual",
    "Issue #": 1,
    "Condition": "CGC 7.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 180,
    "": ""
  },
  {
    "Title": "Batman Annual",
    "Issue #": 3,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman Annual",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman Annual",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman Adventures",
    "Issue #": 12,
    "Condition": "CGC 9.6",
    "Website Notes": "1st Harley Quinn",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 650,
    "": ""
  },
  {
    "Title": "Batman Adventures Annual",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "H Quinn",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Batman & Robin Adventures",
    "Issue #": 5,
    "Condition": "NM",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Batman & Robin Adventures",
    "Issue #": 8,
    "Condition": "NM",
    "Website Notes": "H. Quinn",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Batman & Robin Adventures",
    "Issue #": 28,
    "Condition": "NM",
    "Website Notes": "Joker/H Quinn",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Batman Dark Knight",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "1st print",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Batman Dark Knight",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Batman Dark Knight",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Batman: Harley Quinn",
    "Issue #": "NN",
    "Condition": "CGC 9.8",
    "Website Notes": "1999 1st Harley in DC",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": ""
  },
  {
    "Title": "Batman: Harley Quinn",
    "Issue #": "NN",
    "Condition": "NM",
    "Website Notes": "1999 1st Harley in DC",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Jerry Hayes"
  },
  {
    "Title": "Batman The Klling Joke",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Batman Harley and Ivy",
    "Issue #": "1-3",
    "Condition": "NM-",
    "Website Notes": "Set",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Batman & Superman Adventures: Worlds Finest",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman Beyond",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "Free Origin Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Joe"
  },
  {
    "Title": "Batman Beyond",
    "Issue #": "TPB",
    "Condition": "NM",
    "Website Notes": "1st print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 19.95,
    "": ""
  },
  {
    "Title": "Batman Sword of Azrael",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Batman Sword of Azrael",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Batman Sword of Azrael",
    "Issue #": "1-4",
    "Condition": "NM",
    "Website Notes": "Set",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Batman Family",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Batman Family",
    "Issue #": 8,
    "Condition": "VF+",
    "Website Notes": "Catgirl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Dahlgren"
  },
  {
    "Title": "Batman Family",
    "Issue #": 9,
    "Condition": "VF+",
    "Website Notes": "Catwoman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Dahlgren"
  },
  {
    "Title": "Batman Family",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "1st Batwoman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Batman Special",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 1984,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Jerrys friend"
  },
  {
    "Title": "Batman: Sword of Azrael",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Bednarz"
  },
  {
    "Title": "Beware the Creeper",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "Ditko",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Beware the Creeper",
    "Issue #": 1,
    "Condition": "VG+",
    "Website Notes": "Ditko",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": ""
  },
  {
    "Title": "Binky",
    "Issue #": 68,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Binky",
    "Issue #": 72,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Binky",
    "Issue #": 73,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Binky's Buddies",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Binky's Buddies",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Binky's Buddies",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Binky's Buddies",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Binky's Buddies",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Binky's Buddies",
    "Issue #": 6,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Binky's Buddies",
    "Issue #": 12,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Blackhawk",
    "Issue #": 108,
    "Condition": "CGC 8.5",
    "Website Notes": "1st DC Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 675,
    "": ""
  },
  {
    "Title": "Blackhawk",
    "Issue #": 109,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Blackhawk",
    "Issue #": 140,
    "Condition": "FN-",
    "Website Notes": "2nd Lady Blackhawk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 26,
    "": ""
  },
  {
    "Title": "Blackhawk",
    "Issue #": 141,
    "Condition": "FN",
    "Website Notes": "Cat-Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 32,
    "": ""
  },
  {
    "Title": "Blackhawk",
    "Issue #": 228,
    "Condition": "VF-",
    "Website Notes": "Supermn/Batman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Dahlgren"
  },
  {
    "Title": "Blackhawk",
    "Issue #": 244,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Black Lightning",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Black Lightning",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Bednarz"
  },
  {
    "Title": "Black Lightning",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Black Lightning",
    "Issue #": 2,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Black Lightning",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Black Lightning",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Black Lightning",
    "Issue #": 11,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Blitzkrieg",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Blitzkrieg",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Blitzkrieg",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Blitzkrieg",
    "Issue #": 3,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": ""
  },
  {
    "Title": "Bomba",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Bomba",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Gilligans"
  },
  {
    "Title": "Boy Commandos",
    "Issue #": 11,
    "Condition": "VG",
    "Website Notes": "Infiniy Cover",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Boy Commandos",
    "Issue #": 28,
    "Condition": "G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Boy Commandos",
    "Issue #": "1-2",
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 28,
    "Condition": "NM",
    "Website Notes": "Millenium Edition",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 26,
    "Condition": "VG/F",
    "Website Notes": "2nd Suicide Squad",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 29,
    "Condition": "VG/F",
    "Website Notes": "slt ct",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 215,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 29,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 176,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 30,
    "Condition": "VG+",
    "Website Notes": "3rd JLA",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 255,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 30,
    "Condition": "CGC 4.5",
    "Website Notes": "3rd JLA",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 280,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 31,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 33,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 34,
    "Condition": "G/VG",
    "Website Notes": "color touch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "Ron"
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 36,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 77,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 36,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Trade"
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 43,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 43,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 44,
    "Condition": "VG/F",
    "Website Notes": "Grey Tone C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 46,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 48,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 52,
    "Condition": "F/VF",
    "Website Notes": "Sgt Rock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 89,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 52,
    "Condition": "CGC 7.5",
    "Website Notes": "Sgt Rock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 255,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 55,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 55,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 57,
    "Condition": "F/VF",
    "Website Notes": "1st Metamorpho",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 145,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 58,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 60,
    "Condition": "CGC 7.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 425,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 61,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 63,
    "Condition": "F/VF",
    "Website Notes": "W. Woman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 64,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 67,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 72,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Cutler"
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 72,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Vince"
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 78,
    "Condition": "VF",
    "Website Notes": "W.Woman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 84,
    "Condition": "F/VF",
    "Website Notes": "Sgt Rock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 87,
    "Condition": "VF",
    "Website Notes": "W.Woman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 93,
    "Condition": "FN+",
    "Website Notes": "Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Kent ref"
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 100,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 100,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 103,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 112,
    "Condition": "NM",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 113,
    "Condition": "NM-",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 114,
    "Condition": "VF/NM",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 120,
    "Condition": "NM",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 129,
    "Condition": "VF/NM",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 129,
    "Condition": "VF",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Brave and the Bold",
    "Issue #": 130,
    "Condition": "VF/NM",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Buzzy",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Buzzy",
    "Issue #": 75,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "BCC"
  },
  {
    "Title": "Capt Storm",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Capt Storm",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Harbour"
  },
  {
    "Title": "Capt Storm",
    "Issue #": 10,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Harbour"
  },
  {
    "Title": "Catwoman",
    "Issue #": 51,
    "Condition": "CGC 9.8",
    "Website Notes": "Classic Hughes Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 245,
    "": "Comiclink"
  },
  {
    "Title": "Challengers of the Unknown",
    "Issue #": 3,
    "Condition": "G/VG",
    "Website Notes": "FF Proto by Kirby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "30th Century"
  },
  {
    "Title": "Challengers of the Unknown",
    "Issue #": 5,
    "Condition": "F/G",
    "Website Notes": "CF Missing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "30th Century"
  },
  {
    "Title": "Challengers of the Unknown",
    "Issue #": 11,
    "Condition": "FN+",
    "Website Notes": "Grey tone",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Champion Sports",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Congo Bill",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 145,
    "": ""
  },
  {
    "Title": "Congo Bill",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 145,
    "": ""
  },
  {
    "Title": "Congo Bill",
    "Issue #": 4,
    "Condition": "G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": ""
  },
  {
    "Title": "Crisis",
    "Issue #": 4,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Crisis",
    "Issue #": 6,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Dale Evans",
    "Issue #": 1,
    "Condition": "FN-",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Dale Evans",
    "Issue #": 10,
    "Condition": "VG",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "El Paso"
  },
  {
    "Title": "Dale Evans",
    "Issue #": 19,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Date with Debbi",
    "Issue #": 3,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Date with Debbi",
    "Issue #": 9,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "DC Comics Presents",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "4th Sup/Flash Race",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "GA Collectibles"
  },
  {
    "Title": "DC Comics Presents",
    "Issue #": 26,
    "Condition": "VF",
    "Website Notes": "Teen Titans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Ron"
  },
  {
    "Title": "DC Comics Presents",
    "Issue #": 47,
    "Condition": "F/F+",
    "Website Notes": "Masters of the Universe",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "DC 100 pg Super Spectacular",
    "Issue #": 4,
    "Condition": "CGC 8.0",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 122,
    "": ""
  },
  {
    "Title": "DC 100 pg Super Spectacular",
    "Issue #": 4,
    "Condition": "CGC 6.0",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": "Pedigree"
  },
  {
    "Title": "DC 100 pg Super Spectacular",
    "Issue #": 6,
    "Condition": "FN",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "DC 100 pg Super Spectacular",
    "Issue #": 9,
    "Condition": "PGX 9.4",
    "Website Notes": "Sgt Rock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 145,
    "": ""
  },
  {
    "Title": "DC 100 pg Super Spectacular",
    "Issue #": 16,
    "Condition": "F/VF",
    "Website Notes": "Sgt Rock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "DC Special",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "DC Special",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "DC Special",
    "Issue #": 4,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "DC Special",
    "Issue #": 12,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Bednarz"
  },
  {
    "Title": "DC Special",
    "Issue #": 28,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "DC Special",
    "Issue #": 29,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "DC Super Stars",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": ""
  },
  {
    "Title": "DC Super Stars",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Dahlgren"
  },
  {
    "Title": "DC Super Stars",
    "Issue #": 11,
    "Condition": "FN+",
    "Website Notes": "Zatanna",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": ""
  },
  {
    "Title": "DC Super Stars",
    "Issue #": 13,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4,
    "": ""
  },
  {
    "Title": "DC Super Stars",
    "Issue #": 17,
    "Condition": "FN",
    "Website Notes": "1st Huntress",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Dmitri"
  },
  {
    "Title": "DC Super Star Holiday Special",
    "Issue #": 21,
    "Condition": "NM-",
    "Website Notes": "Miller art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": ""
  },
  {
    "Title": "Deathstroke the Terminator",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Debbi's Dates",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Demon (1972)",
    "Issue #": 1,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Demon (1972)",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Demon (1972)",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Demon (1972)",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Demon (1972)",
    "Issue #": 6,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Demon (1972)",
    "Issue #": 9,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Demon (1972)",
    "Issue #": 12,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Demon (1972)",
    "Issue #": 13,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Demon (1972)",
    "Issue #": 14,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Demon (1972)",
    "Issue #": 15,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Demon (1972)",
    "Issue #": 16,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Demon  (1990)",
    "Issue #": 46,
    "Condition": "NM",
    "Website Notes": "Haunted Tank C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Demon Annual",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "1st Hitman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 80,
    "Condition": "CGC 5.0",
    "Website Notes": "Two Face C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 975,
    "": "Hakes"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 116,
    "Condition": "FA",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 124,
    "Condition": "CGC 1.0",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Poon"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 159,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 140,
    "": "Gilligans"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 162,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 155,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 163,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 215,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 177,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 180,
    "": "Todd"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 185,
    "Condition": "G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 188,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 192,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 130,
    "": "Chris F"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 217,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "house flipper"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 218,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "house flipper"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 219,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "house flipper"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 225,
    "Condition": "CGC 6.0",
    "Website Notes": "1st Martian Manhunter",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5300,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 238,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 68,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 240,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 245,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "house flipper"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 273,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 276,
    "Condition": "FN+",
    "Website Notes": "Batwoman C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 288,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Nick"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 296,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 43,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 298,
    "Condition": "CGC 6.5",
    "Website Notes": "1st SA Clayface",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 835,
    "": "comiclink"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 304,
    "Condition": "VG/F",
    "Website Notes": "Clayface",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Dahlgren"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 327,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 331,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 332,
    "Condition": "VF",
    "Website Notes": "Joker Cvr/Sty",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 334,
    "Condition": "CGC 8.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "Nick"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 336,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Nick"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 359,
    "Condition": "CGC 6.0",
    "Website Notes": "1st Batgirl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1050,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 359,
    "Condition": "VG-",
    "Website Notes": "1st Batgirl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 550,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 363,
    "Condition": "CGC 8.0",
    "Website Notes": "2nd Batgirl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 128,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 363,
    "Condition": "FN",
    "Website Notes": "2nd Batgirl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 365,
    "Condition": "VG/F",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Tim"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 371,
    "Condition": "VG/F",
    "Website Notes": "Batgirl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Nick GE"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 371,
    "Condition": "VG",
    "Website Notes": "Batgirl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 373,
    "Condition": "VG/F",
    "Website Notes": "2nd Mr Freeze",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 377,
    "Condition": "VF",
    "Website Notes": "Riddler C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Joe"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 382,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 385,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": "comiclink"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 386,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 32,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 388,
    "Condition": "CGC 8.5",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 388,
    "Condition": "G/VG",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 400,
    "Condition": "CGC 8.0",
    "Website Notes": "1st Man Bat",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 385,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 400,
    "Condition": "VF",
    "Website Notes": "1st Man Bat",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 135,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 405,
    "Condition": "VG/F",
    "Website Notes": "1st League of Assassins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "2 avail"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 408,
    "Condition": "VF/NM",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 409,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 409,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 411,
    "Condition": "VF-",
    "Website Notes": "1st Talia",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 175,
    "": "Kent ref"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 411,
    "Condition": "VF-",
    "Website Notes": "Adams Sig 1st Talia",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 225,
    "": "Dahlgren"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 411,
    "Condition": "F/VF",
    "Website Notes": "1st Talia",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 411,
    "Condition": "FN",
    "Website Notes": "1st Talia",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 414,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 418,
    "Condition": "VF",
    "Website Notes": "Creeper",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 418,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 419,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 419,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 421,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 421,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 422,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 423,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 424,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 424,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 425,
    "Condition": "NM",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 427,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 428,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 428,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 429,
    "Condition": "VF/NM",
    "Website Notes": "Man Bat",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 431,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 431,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 432,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 436,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 437,
    "Condition": "VF/NM",
    "Website Notes": "Manhunter",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 438,
    "Condition": "VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 439,
    "Condition": "NM-",
    "Website Notes": "100 pg",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 440,
    "Condition": "CGC 9.4",
    "Website Notes": "100 pg",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 155,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 441,
    "Condition": "NM-",
    "Website Notes": "100 pg",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 441,
    "Condition": "VF/NM",
    "Website Notes": "100 pg",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 441,
    "Condition": "VF",
    "Website Notes": "100pg",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 445,
    "Condition": "VF/NM",
    "Website Notes": "100 pg",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 448,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 455,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 457,
    "Condition": "VF/NM",
    "Website Notes": "Origin retold",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 462,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 463,
    "Condition": "VF",
    "Website Notes": "1st Black Spider",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 470,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 472,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 474,
    "Condition": "VF/NM",
    "Website Notes": "1st Deadshot",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 477,
    "Condition": "NM-",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 478,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 482,
    "Condition": "NM-",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 494,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 497,
    "Condition": "VF/NM",
    "Website Notes": "Batgirl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Nick"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 498,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 500,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 501,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 502,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 505,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 505,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 506,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 532,
    "Condition": "NM",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "TTreasures"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 532,
    "Condition": "VF/NM",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ann Arbor"
  },
  {
    "Title": "Detective Comics",
    "Issue #": 533,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 554,
    "Condition": "NM",
    "Website Notes": "1st Black Canary",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 564,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 569,
    "Condition": "NM+",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 569,
    "Condition": "VF+",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 569,
    "Condition": "F/VF",
    "Website Notes": "Canadian Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 570,
    "Condition": "VF/NM",
    "Website Notes": "Joker C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 570,
    "Condition": "FN",
    "Website Notes": "Canadian Variant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 575,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 576,
    "Condition": "VF",
    "Website Notes": "McFarlane",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 27,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 576,
    "Condition": "NM+",
    "Website Notes": "McFarlane",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 577,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": 10,
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Detective Comics",
    "Issue #": 578,
    "Condition": "NM-",
    "Website Notes": "McFarlane",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Doom Patrol",
    "Issue #": 90,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Doom Patrol",
    "Issue #": 98,
    "Condition": "F/VF",
    "Website Notes": "1st Mr 103",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Dahlgren"
  },
  {
    "Title": "Doom Patrol",
    "Issue #": 99,
    "Condition": "VG/F",
    "Website Notes": "1st Beast Boy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": ""
  },
  {
    "Title": "Doom Patrol",
    "Issue #": 121,
    "Condition": "VF+",
    "Website Notes": "Death of DP",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Doom Patrol",
    "Issue #": 122,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 34,
    "": ""
  },
  {
    "Title": "Doorway to Nightmare",
    "Issue #": 5,
    "Condition": "NM",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Doorway to Nightmare",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Palm Beach"
  },
  {
    "Title": "80 Page Giant",
    "Issue #": 5,
    "Condition": "FN+",
    "Website Notes": "Batman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Nick"
  },
  {
    "Title": "80 Page Giant",
    "Issue #": 7,
    "Condition": "F/VF",
    "Website Notes": "Sgt Rock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Elvira Special",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Falling in Love",
    "Issue #": 16,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Falling in Love",
    "Issue #": 27,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Falling in Love",
    "Issue #": 136,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Romance",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Falling in Love",
    "Issue #": 137,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Romance",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Firestorm",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 2004,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Firestorm",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Firestorm",
    "Issue #": 6,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 105,
    "Condition": "CGC 4.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 800,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 106,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 355,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 120,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 124,
    "Condition": "VF",
    "Website Notes": "Last .10 Iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 128,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 132,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 134,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 136,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 147,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 147,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 149,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 150,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 152,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 154,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 155,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 156,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 158,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 159,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 161,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 168,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 169,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 170,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 172,
    "Condition": "FN+",
    "Website Notes": "Grodd",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 172,
    "Condition": "FN",
    "Website Notes": "Grodd",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 172,
    "Condition": "VG",
    "Website Notes": "Grodd",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 175,
    "Condition": "VF-",
    "Website Notes": "Flash/Sup race",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 175,
    "Condition": "VF+",
    "Website Notes": "Flash/Sup race",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 211,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 219,
    "Condition": "VF/NM",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 225,
    "Condition": "VF",
    "Website Notes": "Zoom c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 229,
    "Condition": "VF",
    "Website Notes": "100 PG Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Bednarz"
  },
  {
    "Title": "Flash",
    "Issue #": 233,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Flash",
    "Issue #": 323,
    "Condition": "NM-",
    "Website Notes": "Flash vs Flash",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Flash Annual",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": 1963,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Dahlgren"
  },
  {
    "Title": "Flash (1987)",
    "Issue #": 197,
    "Condition": "NM",
    "Website Notes": "1st Zoom",
    "Personal Notes (Not on website)": 50,
    "Cost Basis": 80,
    "": ""
  },
  {
    "Title": "Flash Season Zero",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Forbidden Tales of Dark Mansion",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forbidden Tales of Dark Mansion",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forbidden Tales of Dark Mansion",
    "Issue #": 9,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forbidden Tales of Dark Mansion",
    "Issue #": 10,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forbidden Tales of Dark Mansion",
    "Issue #": 11,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forever People",
    "Issue #": 1,
    "Condition": "CGC 8.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "Tommy"
  },
  {
    "Title": "Forever People",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Tommy"
  },
  {
    "Title": "Forever People",
    "Issue #": 2,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forever People",
    "Issue #": 3,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forever People",
    "Issue #": 3,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forever People",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": "1st Glorious Godfrey",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forever People",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forever People",
    "Issue #": 6,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forever People",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forever People",
    "Issue #": 9,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forever People",
    "Issue #": 10,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forever People",
    "Issue #": 11,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Forever People",
    "Issue #": 11,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Four Star Battle Tales",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Four Star Spectacular",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Four Star Spectacular",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Four Star Spectacular",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Fox and the Crow",
    "Issue #": 32,
    "Condition": "VG",
    "Website Notes": "Precode",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Green Valley"
  },
  {
    "Title": "Freedom Fighters",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Frontier Fighters",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Frontier Fighters",
    "Issue #": 2,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Frontier Fighters",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Frontier Fighters",
    "Issue #": 4,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Frontier Fighters",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Frontier Fighters",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Frontier Fighters",
    "Issue #": 7,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Frontier Fighters",
    "Issue #": 7,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Frontier Fighters",
    "Issue #": 8,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Fury of Firestorm",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Fury of Firestorm",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Fury of Firestorm",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 56,
    "": ""
  },
  {
    "Title": "Fury of Firestorm",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "Killer Frost",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Fury of Firestorm",
    "Issue #": 23,
    "Condition": "NM",
    "Website Notes": "1st Felicity Smoak",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Gangbusters",
    "Issue #": 42,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Rapud City"
  },
  {
    "Title": "Gangbusters",
    "Issue #": 43,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Rapud City"
  },
  {
    "Title": "Ghosts",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "tommy"
  },
  {
    "Title": "Ghosts",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Ghosts",
    "Issue #": 6,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 8,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Ghosts",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 13,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 14,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 15,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 16,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 17,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 18,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 19,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 20,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 21,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 22,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 23,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 24,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 25,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 26,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 27,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 28,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 30,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 31,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 32,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 33,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Ghosts",
    "Issue #": 36,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "30th Century"
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 44,
    "Condition": "VG+",
    "Website Notes": "1st DC Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": "Green Valley"
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 47,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 53,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 54,
    "Condition": "VG",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 55,
    "Condition": "FN-",
    "Website Notes": "Sgt Rock Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Matt"
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 56,
    "Condition": "CGC 6.0",
    "Website Notes": "Sgt Rock Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 360,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 56,
    "Condition": "VG",
    "Website Notes": "Sgt Rock Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 59,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 66,
    "Condition": "FA",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 68,
    "Condition": "CGC 6.0",
    "Website Notes": "The Rock'",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 515,
    "": "Pedigree"
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 83,
    "Condition": "G/VG",
    "Website Notes": "Grey Tone",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Harbour"
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 85,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Annandale"
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 87,
    "Condition": "CGC 5.5",
    "Website Notes": "1st Haunted Tank",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 590,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 91,
    "Condition": "CGC 8.0",
    "Website Notes": "1st HT Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 385,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 96,
    "Condition": "FN+",
    "Website Notes": "Heath Grey Tone",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Vince"
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 99,
    "Condition": "FN",
    "Website Notes": "Grey Tone",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 99,
    "Condition": "VG/F",
    "Website Notes": "2 Avail",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 101,
    "Condition": "VG+",
    "Website Notes": "Grey Tone",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 26,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 102,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 103,
    "Condition": "G/VG",
    "Website Notes": "Grey Tone",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 105,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 106,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 107,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 123,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Harbour"
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 152,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "G.I. Combat",
    "Issue #": 154,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Girls' Love Stories",
    "Issue #": 65,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Girls' Love Stories",
    "Issue #": 67,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Girl's Romances",
    "Issue #": 8,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "30th Century"
  },
  {
    "Title": "Girl's Romances",
    "Issue #": 105,
    "Condition": "GD",
    "Website Notes": "Lichtenstein",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Bob"
  },
  {
    "Title": "Green Arrow (1983)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 1,
    "Condition": "CGC 6.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1800,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1300,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 7,
    "Condition": "G/VG",
    "Website Notes": "1st Sinestro",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Gilligans"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 8,
    "Condition": "VG/F",
    "Website Notes": "Grey Tone c",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 8,
    "Condition": "VG",
    "Website Notes": "Grey Tone c",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Gilligans"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 11,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": 70,
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 12,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": 95,
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 15,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": 65,
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 15,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 17,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": 90,
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 20,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": 65,
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 20,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Dahlgren"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 24,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": 95,
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 26,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": 75,
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 27,
    "Condition": "FN/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": 90,
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 28,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": 80,
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 29,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 30,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Harbour"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 30,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Bednarz"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 33,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": 125,
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 40,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 40,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": 90,
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 40,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 40,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 41,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 45,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Gilligans"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 47,
    "Condition": "VF/NM",
    "Website Notes": "Dr Polaris",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 48,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Gilligans"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 63,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 67,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 68,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": 48,
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 68,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Gilligans"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 73,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Gilligans"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 76,
    "Condition": "VG/F",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Bednarz"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 76,
    "Condition": "GD+",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Gilligans"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 78,
    "Condition": "VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ann Arbor"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 78,
    "Condition": "VG/F",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 80,
    "Condition": "VG",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 81,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 81,
    "Condition": "VG",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Gilligans"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 82,
    "Condition": "VF/NM",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Ann Arbor"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 82,
    "Condition": "VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 82,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 83,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 84,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 85,
    "Condition": "VG/F",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Cutler"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 85,
    "Condition": "VG-",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 86,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 86,
    "Condition": "VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 87,
    "Condition": "CGC 6.5",
    "Website Notes": "1st John Stewart",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 470,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 87,
    "Condition": "FN-",
    "Website Notes": "1st John Stewart",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 87,
    "Condition": "VG",
    "Website Notes": "1st John Stewart",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "gilligans"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 88,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 88,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 89,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 89,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 89,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 90,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 90,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Gilligans"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 100,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Bednarz"
  },
  {
    "Title": "Green Lantern",
    "Issue #": 116,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": "141-143",
    "Condition": "NM",
    "Website Notes": "Omega Men Set",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Green Lantern",
    "Issue #": 201,
    "Condition": "CGC 9.8",
    "Website Notes": "Green Lantern Corps",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": ""
  },
  {
    "Title": "Harley and Ivy",
    "Issue #": "Love on the Lam",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Harley Quinn Worlds at War",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Hawkman",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 115,
    "": ""
  },
  {
    "Title": "Hawkman",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "Loose Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Hawkman",
    "Issue #": 2,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 115,
    "": ""
  },
  {
    "Title": "Hawkman",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": ""
  },
  {
    "Title": "Hawkman",
    "Issue #": 4,
    "Condition": "FN+",
    "Website Notes": "1st Zatanna",
    "Personal Notes (Not on website)": "Pence stamp",
    "Cost Basis": 1025,
    "": ""
  },
  {
    "Title": "Hawkman",
    "Issue #": 6,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Hawkman",
    "Issue #": 7,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Hawkman",
    "Issue #": 9,
    "Condition": "VF",
    "Website Notes": "Atom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Hawkman",
    "Issue #": 10,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "TTreasures"
  },
  {
    "Title": "Hawkman",
    "Issue #": 11,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Hawkman",
    "Issue #": 12,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Hawkman",
    "Issue #": 13,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Hawkman",
    "Issue #": 14,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "TTreasures"
  },
  {
    "Title": "Hawkman",
    "Issue #": 14,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Hawkman",
    "Issue #": 15,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "TTreasures"
  },
  {
    "Title": "Hawkman",
    "Issue #": 20,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Heart Throbs",
    "Issue #": 55,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Heart Throbs",
    "Issue #": 56,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Heart Throbs",
    "Issue #": 57,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Heart Throbs",
    "Issue #": 64,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Heart Throbs",
    "Issue #": 65,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Heart Throbs",
    "Issue #": 113,
    "Condition": "FN",
    "Website Notes": "classic c",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Heart Throbs",
    "Issue #": 127,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Heart Throbs",
    "Issue #": 135,
    "Condition": "F/VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Heart Throbs",
    "Issue #": 140,
    "Condition": "VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Hopalong Cassidy",
    "Issue #": 131,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 42,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Brian"
  },
  {
    "Title": "House of Mystery",
    "Issue #": 32,
    "Condition": "VG",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "AHeroes"
  },
  {
    "Title": "House of Mystery",
    "Issue #": 58,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 77,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "House of Mystery",
    "Issue #": 103,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 108,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 114,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 141,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "BCC"
  },
  {
    "Title": "House of Mystery",
    "Issue #": 143,
    "Condition": "NM-",
    "Website Notes": "1st Jonn Jonzz",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 260,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 145,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 146,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 148,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 153,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 154,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 26,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 172,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 173,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 175,
    "Condition": "FN-",
    "Website Notes": "1st Cain",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "BCC"
  },
  {
    "Title": "House of Mystery",
    "Issue #": 178,
    "Condition": "F/VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 180,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 180,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 181,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 182,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 184,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 185,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 187,
    "Condition": "VF",
    "Website Notes": "Adams C Toth",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 192,
    "Condition": "NM-",
    "Website Notes": "Adams,Wood",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 192,
    "Condition": "VF/NM",
    "Website Notes": "Adams,Wood",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 193,
    "Condition": "VF/NM",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 193,
    "Condition": "VF",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "30th Century"
  },
  {
    "Title": "House of Mystery",
    "Issue #": 194,
    "Condition": "VF/NM",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 195,
    "Condition": "VG/F",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 196,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 198,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 199,
    "Condition": "VF/NM",
    "Website Notes": "Adams cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 199,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 200,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 200,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 200,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 204,
    "Condition": "VF+",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 204,
    "Condition": "F/VF",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "calgary"
  },
  {
    "Title": "House of Mystery",
    "Issue #": 206,
    "Condition": "VF",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "tommy"
  },
  {
    "Title": "House of Mystery",
    "Issue #": 214,
    "Condition": "FN+",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Tim"
  },
  {
    "Title": "House of Mystery",
    "Issue #": 221,
    "Condition": "VF/NM",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Steve"
  },
  {
    "Title": "House of Mystery",
    "Issue #": 236,
    "Condition": "F/VF",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "30th century"
  },
  {
    "Title": "House of Mystery",
    "Issue #": 252,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 256,
    "Condition": "VF/NM",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 290,
    "Condition": "NM-",
    "Website Notes": "1st I Vampire",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "House of Mystery",
    "Issue #": 290,
    "Condition": "VF/NM",
    "Website Notes": "1st I Vampire",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans"
  },
  {
    "Title": "House of Mystery",
    "Issue #": 321,
    "Condition": "NM",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "30th Century"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "Grey Tone Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 280,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 1,
    "Condition": "CGC 5.0",
    "Website Notes": "Grey Tone Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 345,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 35,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 43,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 54,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 58,
    "Condition": "VF+",
    "Website Notes": "Origin Mark Merlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 58,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 60,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 61,
    "Condition": "CGC 6.0",
    "Website Notes": "1st Eclipso",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 185,
    "": "comiclink"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 61,
    "Condition": "VG/F",
    "Website Notes": "1st Eclipso",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 215,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 65,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 66,
    "Condition": "FN",
    "Website Notes": "1st Eclipso Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 78,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 79,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 81,
    "Condition": "VF",
    "Website Notes": "1st Mystery",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 145,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 81,
    "Condition": "VG/F",
    "Website Notes": "1st Mystery",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 83,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 84,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 85,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "tommy"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 86,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 87,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 87,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 88,
    "Condition": "VG/F",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Kent ref"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 89,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 89,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Bednarz"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 90,
    "Condition": "VF/NM",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 90,
    "Condition": "F/VF",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Kent ref"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 91,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Kent ref"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 92,
    "Condition": "CGC 8.0",
    "Website Notes": "1st Swamp Thing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1900,
    "": "Bednarz"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 92,
    "Condition": "CGC 7.5",
    "Website Notes": "1st Swamp Thing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1550,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 92,
    "Condition": "CBCS 5.0",
    "Website Notes": "1st Swamp Thing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 900,
    "": "Annandale"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 93,
    "Condition": "F/VF",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": "30th Century"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 94,
    "Condition": "F/VF",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Bednarz"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 98,
    "Condition": "VF",
    "Website Notes": "Kaluta",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Frederick"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 103,
    "Condition": "F/VF",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "30th century"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 198,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Dahlgren"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 109,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "House of Secrets",
    "Issue #": 112,
    "Condition": "NM-",
    "Website Notes": "Grey Tone Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Dahlgren"
  },
  {
    "Title": "House of Secrets",
    "Issue #": 115,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Dahlgren"
  },
  {
    "Title": "Jackie Gleason",
    "Issue #": 8,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Jackie Gleason",
    "Issue #": 9,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Jimmy Wakely",
    "Issue #": 1,
    "Condition": "P",
    "Website Notes": "One page missing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Jimmy Wakely",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Jimmy Wakely",
    "Issue #": 13,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "JLA",
    "Issue #": 11,
    "Condition": "NM",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Joker",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Joker",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Joker",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Joker",
    "Issue #": 2,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Joker",
    "Issue #": 3,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Joker",
    "Issue #": 4,
    "Condition": "",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Joker",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Joker",
    "Issue #": 9,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Joker Daffy Duck",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Jonah Hex",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 56,
    "": ""
  },
  {
    "Title": "Jonah Hex",
    "Issue #": 1,
    "Condition": "CGC 9.6",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": ""
  },
  {
    "Title": "Jonah Hex",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Jonah Hex",
    "Issue #": 2,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Jonah Hex",
    "Issue #": 8,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Justice League International Annual",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 1,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": "Chops"
  },
  {
    "Title": "Justice League of America",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 900,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 1,
    "Condition": "CGC 2.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 700,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 6,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 7,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 8,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 9,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 15,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 16,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 18,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 20,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 21,
    "Condition": "G/VG",
    "Website Notes": "Crisis on Earth-2",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 22,
    "Condition": "VG",
    "Website Notes": "Crisis on Earth-2",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 25,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 29,
    "Condition": "CGC 5.0",
    "Website Notes": "1st SA Starman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 32,
    "Condition": "G+",
    "Website Notes": "Intro Brain Storm",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 33,
    "Condition": "CGC 7.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Nick"
  },
  {
    "Title": "Justice League of America",
    "Issue #": 33,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 35,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 36,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 40,
    "Condition": "FN/VF",
    "Website Notes": "3rd SA Penguin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 41,
    "Condition": "VG/F",
    "Website Notes": "Intro The Key",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 54,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 54,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 75,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 80,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 81,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 82,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 91,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Bednarz"
  },
  {
    "Title": "Justice League of America",
    "Issue #": 95,
    "Condition": "V/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 108,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 113,
    "Condition": "F/VF",
    "Website Notes": "100 pg",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 113,
    "Condition": "VF/NM",
    "Website Notes": "100 pg",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 114,
    "Condition": "NM-",
    "Website Notes": "100 pg",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 117,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 118,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 122,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 130,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Justice League of America",
    "Issue #": 134,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Kamandi",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Kamandi",
    "Issue #": 4,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Kamandi",
    "Issue #": 9,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Kamandi",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Kamandi",
    "Issue #": 19,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Kamandi",
    "Issue #": 29,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Korak",
    "Issue #": 46,
    "Condition": "VF/NM",
    "Website Notes": "1st Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Larry Harmon's Laurel & Hardy",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Last Days of the Justice Society",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Leave it to Binky",
    "Issue #": 15,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Leave it to Binky",
    "Issue #": 64,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Leave it to Binky",
    "Issue #": 65,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Leave it to Binky",
    "Issue #": 67,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Leave it to Binky",
    "Issue #": 67,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Leave it to Binky",
    "Issue #": 67,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Leave it to Binky",
    "Issue #": 71,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Legends of Daniel Boone",
    "Issue #": 2,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 140,
    "": ""
  },
  {
    "Title": "Legends of Daniel Boone",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 140,
    "": ""
  },
  {
    "Title": "Lois Lane Annual",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Many Loves of Dobie Gillis",
    "Issue #": 26,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Masters of the Universe",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Masters of the Universe",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "Newsstand",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans"
  },
  {
    "Title": "Metal Men",
    "Issue #": 1,
    "Condition": "CGC 8.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 325,
    "": ""
  },
  {
    "Title": "Metal Men",
    "Issue #": 45,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Metamorpho",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Miss Beverly Hills of Hollywood",
    "Issue #": 7,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 1,
    "Condition": "VG+",
    "Website Notes": "1st App",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "1st App",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "1st Granny",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "1st Granny",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 2,
    "Condition": "FN-",
    "Website Notes": "1st Granny",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 3,
    "Condition": "VF",
    "Website Notes": "1st Dr Bedlam",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "1st Dr Bedlam",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 4,
    "Condition": "FN-",
    "Website Notes": "1st Big Barda",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 6,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 7,
    "Condition": "VF+",
    "Website Notes": "1st Kanto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "1st Giloina",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 8,
    "Condition": "NM-",
    "Website Notes": "1st Gilotina",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "1st Himon",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 10,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 11,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 12,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 13,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 14,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 15,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 16,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 17,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Mister Miracle",
    "Issue #": 18,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "More Fun Comics",
    "Issue #": 65,
    "Condition": "P",
    "Website Notes": "Coverless",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Frederick"
  },
  {
    "Title": "More Fun Comics",
    "Issue #": 72,
    "Condition": "CGC 5.0",
    "Website Notes": "Dr Fate",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1525,
    "": "PBA"
  },
  {
    "Title": "Mr District Attorney",
    "Issue #": 18,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Mr District Attorney",
    "Issue #": 19,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Mr District Attorney",
    "Issue #": 52,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 4,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 9,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 10,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 12,
    "Condition": "VG/F",
    "Website Notes": "1st SA Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 13,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 14,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 15,
    "Condition": "FN+",
    "Website Notes": "Kirby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 16,
    "Condition": "FN",
    "Website Notes": "Kirby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 17,
    "Condition": "VG+",
    "Website Notes": "Grey Tone Kirby Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "GA Collectibles"
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 18,
    "Condition": "FN",
    "Website Notes": "Kirby C/A",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 19,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 20,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 21,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 23,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 23,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 25,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 59,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 81,
    "Condition": "FN",
    "Website Notes": "2nd Doom Patrol",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 82,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 83,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 84,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "My Greatest Adventure",
    "Issue #": 85,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 27,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "GA Collectibles"
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 36,
    "Condition": "VG/F",
    "Website Notes": "Grey Tone Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Brian"
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 39,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Brian"
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 54,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 54,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 55,
    "Condition": "FN",
    "Website Notes": "Grey Tone C",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 56,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Rapid City"
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 58,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 60,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 62,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 63,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 82,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 83,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 87,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 90,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 91,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 95,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 97,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Mystery in Space",
    "Issue #": 103,
    "Condition": "FN+",
    "Website Notes": "1st Ultra",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "New Adventures of Charlie Chan",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Vince"
  },
  {
    "Title": "New Adventures of Charlie Chan",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "New Gods",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 180,
    "": ""
  },
  {
    "Title": "New Gods",
    "Issue #": 1,
    "Condition": "CGC 9.6",
    "Website Notes": "White Pages",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "TTreasures"
  },
  {
    "Title": "New Gods",
    "Issue #": 1,
    "Condition": "CGC 8.5",
    "Website Notes": "White Pages",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Tommy"
  },
  {
    "Title": "New Gods",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "New Gods",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "New Gods",
    "Issue #": 7,
    "Condition": "FN",
    "Website Notes": "1sr Steppenwolf",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "New Gods",
    "Issue #": 8,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "New Gods",
    "Issue #": 9,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "New Gods",
    "Issue #": 10,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "New Teen Titans",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "New Teen Titans",
    "Issue #": 2,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": ""
  },
  {
    "Title": "New Teen Titans",
    "Issue #": 27,
    "Condition": "VF/NM",
    "Website Notes": "Atari Force insert",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "New Teen Titans Special",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 1984,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Omac",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Omac",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Omac",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Omac",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Omac",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 39,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 48,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 49,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 50,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 52,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 62,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "TTreasures"
  },
  {
    "Title": "Our Army at War",
    "Issue #": 72,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 78,
    "Condition": "F/VF",
    "Website Notes": "Battle Nurse",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 78,
    "Condition": "CGC 6.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 190,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 81,
    "Condition": "FA",
    "Website Notes": "Sgt Rock proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 85,
    "Condition": "VG/F",
    "Website Notes": "1st Ice Cream Soldier",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Matt"
  },
  {
    "Title": "Our Army at War",
    "Issue #": 95,
    "Condition": "CGC 5.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 98,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "TTreasures"
  },
  {
    "Title": "Our Army at War",
    "Issue #": 99,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Harbour"
  },
  {
    "Title": "Our Army at War",
    "Issue #": 100,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Dahlgren"
  },
  {
    "Title": "Our Army at War",
    "Issue #": 102,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 103,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Harbour"
  },
  {
    "Title": "Our Army at War",
    "Issue #": 103,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 107,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Harbour"
  },
  {
    "Title": "Our Army at War",
    "Issue #": 110,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "TTreasures"
  },
  {
    "Title": "Our Army at War",
    "Issue #": 118,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 118,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 120,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 120,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 120,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 123,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 128,
    "Condition": "VG+",
    "Website Notes": "Origin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 147,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Harbour"
  },
  {
    "Title": "Our Army at War",
    "Issue #": 148,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Harbour"
  },
  {
    "Title": "Our Army at War",
    "Issue #": 151,
    "Condition": "FN",
    "Website Notes": "1st Enemy Ace",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 162,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 168,
    "Condition": "VG",
    "Website Notes": "1st Unknown Soldier",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "stan"
  },
  {
    "Title": "Our Army at War",
    "Issue #": 269,
    "Condition": "F/VF",
    "Website Notes": "100 Page Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Our Army at War",
    "Issue #": 275,
    "Condition": "F/VF",
    "Website Notes": "100 Page Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Pre Code",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Todd"
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 6,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 14,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 16,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 24,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 49,
    "Condition": "VG/F",
    "Website Notes": "1st Pooch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 51,
    "Condition": "FN",
    "Website Notes": "Grey Tone",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 59,
    "Condition": "CGC 5.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 60,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 71,
    "Condition": "VG/F",
    "Website Notes": "Grey Tone",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 71,
    "Condition": "FN-",
    "Website Notes": "Grey Tone",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 72,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 94,
    "Condition": "VF+",
    "Website Notes": "Grey Tone",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 94,
    "Condition": "VF+",
    "Website Notes": "Grey Tone",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "GA Collectibles"
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 95,
    "Condition": "VG/F",
    "Website Notes": "Devil Dog Begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Vince"
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 96,
    "Condition": "FN",
    "Website Notes": "Violent Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Vince"
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 97,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Vince"
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 123,
    "Condition": "VG/F",
    "Website Notes": "1st Losers",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Vince"
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 159,
    "Condition": "F/VF",
    "Website Notes": "Kirby",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Our Fighting Forces",
    "Issue #": 162,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Phantom Stranger",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "gilligans"
  },
  {
    "Title": "Phantom Stranger",
    "Issue #": 1,
    "Condition": "CGC 7.5",
    "Website Notes": "White Pages",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 105,
    "": "Clink"
  },
  {
    "Title": "Phantom Stranger",
    "Issue #": 17,
    "Condition": "NM-",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Phantom Stranger",
    "Issue #": 18,
    "Condition": "NM-",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Phantom Stranger",
    "Issue #": 20,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Phantom Stranger",
    "Issue #": 32,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Phantom Stranger",
    "Issue #": 41,
    "Condition": "VF/NM",
    "Website Notes": "Deadman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Picture Stories From mthe Bible",
    "Issue #": 2,
    "Condition": "VG",
    "Website Notes": 1942,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Gilligans"
  },
  {
    "Title": "Plastic Man (1967)",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Plop",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Plop",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Plop",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Plop",
    "Issue #": 14,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Plop",
    "Issue #": 18,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Plop",
    "Issue #": 20,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Preacher",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 129,
    "": ""
  },
  {
    "Title": "Real Fact Comics",
    "Issue #": 10,
    "Condition": "VG/F",
    "Website Notes": "Vigilante",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Frederick"
  },
  {
    "Title": "Real Fact Comics",
    "Issue #": 12,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Frederick"
  },
  {
    "Title": "Rima",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Rip Hunter",
    "Issue #": 1,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Roanoke"
  },
  {
    "Title": "Rip Hunter",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Rip Hunter",
    "Issue #": 11,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Robin Hood Tales",
    "Issue #": 14,
    "Condition": "G/VG",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Roanoke"
  },
  {
    "Title": "Romance Trail",
    "Issue #": 3,
    "Condition": "VG-",
    "Website Notes": "Toth Art",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Rudolph Annual",
    "Issue #": 1962,
    "Condition": "PGX 5.0",
    "Website Notes": "Scarce",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Sandman (1974)",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Sandman (1974)",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Sandman (1974)",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Sandman (1974)",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Sandman (1974)",
    "Issue #": 5,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Sandman (1974)",
    "Issue #": 6,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Sandman (1989)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": ""
  },
  {
    "Title": "Sandman (1989)",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Sea Devils",
    "Issue #": 8,
    "Condition": "FN+",
    "Website Notes": "Grey Tone Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Dahlgren"
  },
  {
    "Title": "Sea Devils",
    "Issue #": 15,
    "Condition": "VG/F",
    "Website Notes": "Grey Tone Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Secret Hearts",
    "Issue #": 32,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Romance",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Secret Origins",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "1961 Annual",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Roanoke"
  },
  {
    "Title": "Secret Origins",
    "Issue #": 14,
    "Condition": "NM",
    "Website Notes": "Jonah Hex",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Secrets of Haunted House",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Lehigh Valley"
  },
  {
    "Title": "Secrets of Sinister House",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Secrets of Sinister House",
    "Issue #": 8,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Secrets of Sinister House",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Secrets of Sinister House",
    "Issue #": 11,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Sgt Bilko",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "Trade"
  },
  {
    "Title": "Sgt Bilko's Pvt Doberman",
    "Issue #": 7,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Sgt Rock",
    "Issue #": 336,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Sgt Rock",
    "Issue #": 339,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Sgt Rock",
    "Issue #": 340,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Sgt Rock",
    "Issue #": 347,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Sgt Rock",
    "Issue #": 350,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Sgt Rock",
    "Issue #": 351,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Sgt Rock",
    "Issue #": 352,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Sgt Rock",
    "Issue #": 353,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Sgt Rock's Prize Battle Tales",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": 1964,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Sgt Rock's Prize Battle Tales",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": 1964,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Shadow",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "Kaluta",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ron"
  },
  {
    "Title": "Shazam (1973)",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Shazam (1973)",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Shazam (1973)",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Shazam (1973)",
    "Issue #": 3,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Shazam (1973)",
    "Issue #": 8,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Shazam (1973)",
    "Issue #": 12,
    "Condition": "VF+",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Shazam (1973)",
    "Issue #": 12,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Shazam (1973)",
    "Issue #": 17,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Shazam (1973)",
    "Issue #": 18,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Shazam (1987)",
    "Issue #": "1-4",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Shazam (1987)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 1,
    "Condition": "P",
    "Website Notes": "No Back Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 130,
    "": "30th Century"
  },
  {
    "Title": "Showcase",
    "Issue #": 8,
    "Condition": "FN-",
    "Website Notes": "2nd SA Flash",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1500,
    "": "House Flipper"
  },
  {
    "Title": "Showcase",
    "Issue #": 13,
    "Condition": "FN+",
    "Website Notes": "3rd SA Flash",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1000,
    "": "House Flipper"
  },
  {
    "Title": "Showcase",
    "Issue #": 14,
    "Condition": "VG/F",
    "Website Notes": "4th SA Flash",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 800,
    "": "House Flipper"
  },
  {
    "Title": "Showcase",
    "Issue #": 15,
    "Condition": "VG/F",
    "Website Notes": "1st Space Ranger",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "House Flipper"
  },
  {
    "Title": "Showcase",
    "Issue #": 16,
    "Condition": "VG/F",
    "Website Notes": "2nd Space Ranger",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "House Flipper"
  },
  {
    "Title": "Showcase",
    "Issue #": 22,
    "Condition": "CGC 4.5",
    "Website Notes": "1st SA Green Lantern",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3900,
    "": "PBA"
  },
  {
    "Title": "Showcase",
    "Issue #": 34,
    "Condition": "VG",
    "Website Notes": "1st SA Atom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 34,
    "Condition": "F/VF",
    "Website Notes": "Restored",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 35,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 35,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 35,
    "Condition": "FN+",
    "Website Notes": "Atom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 36,
    "Condition": "F/VF",
    "Website Notes": "Atom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 36,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 67,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 36,
    "Condition": "coverless",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 40,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 41,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 41,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 42,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Green Valley"
  },
  {
    "Title": "Showcase",
    "Issue #": 42,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Green Valley"
  },
  {
    "Title": "Showcase",
    "Issue #": 43,
    "Condition": "F/VF",
    "Website Notes": "Dr No",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 185,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 45,
    "Condition": "F/VF",
    "Website Notes": "Sgt Rock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 68,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 45,
    "Condition": "VG/F",
    "Website Notes": "Sgt Rock",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 50,
    "Condition": "VF-",
    "Website Notes": "I-Spy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 50,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 51,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 53,
    "Condition": "FN",
    "Website Notes": "GI Joe",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Harbour"
  },
  {
    "Title": "Showcase",
    "Issue #": 54,
    "Condition": "VG/F",
    "Website Notes": "GI Joe",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Harbour"
  },
  {
    "Title": "Showcase",
    "Issue #": 55,
    "Condition": "CGC 8.5",
    "Website Notes": "Solomon Grundy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 395,
    "": "Lone Star"
  },
  {
    "Title": "Showcase",
    "Issue #": 55,
    "Condition": "FN",
    "Website Notes": "Solomon Grundy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 185,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 55,
    "Condition": "GD",
    "Website Notes": "Solomon Grundy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 57,
    "Condition": "G/VG",
    "Website Notes": "Enemy Ace",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 59,
    "Condition": "CGC 9.2",
    "Website Notes": "Teen Titans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 59,
    "Condition": "FN",
    "Website Notes": "Teen Titans",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 60,
    "Condition": "FN+",
    "Website Notes": "Spectre",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 60,
    "Condition": "VG/F",
    "Website Notes": "Spectre",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 62,
    "Condition": "F/VF",
    "Website Notes": "Inferior Five",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 73,
    "Condition": "FN+",
    "Website Notes": "Creeper",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 78,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 74,
    "Condition": "FN",
    "Website Notes": "Anthro",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 74,
    "Condition": "VG",
    "Website Notes": "Anthro",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Bednarz"
  },
  {
    "Title": "Showcase",
    "Issue #": 75,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 78,
    "Condition": "F/VF",
    "Website Notes": "Jonny Double",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 81,
    "Condition": "VG-",
    "Website Notes": "Windy and Willy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 92,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Showcase",
    "Issue #": 97,
    "Condition": "VG/F",
    "Website Notes": "Power Girl",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Silver Age Classics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Action Comics 252",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Silver Age Classics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Adventure Comics 247",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Silver Age Classics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Brave and the Bold 28",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Silver Age Classics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Green Lantern 76",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Silver Age Classics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Showcase 4",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Silver Age Classics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Showcase 22",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Spectre",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Spectre",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Spectre",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Spectre",
    "Issue #": 6,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Spectre",
    "Issue #": 8,
    "Condition": "CGC 9.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Tim"
  },
  {
    "Title": "Spectre",
    "Issue #": 9,
    "Condition": "FN+",
    "Website Notes": "Wrightson Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Vince"
  },
  {
    "Title": "Star Spangled Comics",
    "Issue #": 10,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 150,
    "": ""
  },
  {
    "Title": "Star Spangled Comics",
    "Issue #": 11,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 150,
    "": ""
  },
  {
    "Title": "Star Spangled Comics",
    "Issue #": 86,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Star Spangled Comics",
    "Issue #": 125,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Star Spangled Comics",
    "Issue #": 128,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": "132 (#2)",
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Beyond"
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 13,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Vince"
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 45,
    "Condition": "G+",
    "Website Notes": "1st Grey Tone C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 45,
    "Condition": "VG/F",
    "Website Notes": "1st Grey Tone C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 45,
    "Condition": "VG",
    "Website Notes": "1st Grey Tone C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 48,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 61,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 75,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "trade"
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 79,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 81,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 90,
    "Condition": "GD",
    "Website Notes": "1st Dino Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Fox"
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 94,
    "Condition": "GD+",
    "Website Notes": "Ghost Ace",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 98,
    "Condition": "FN+",
    "Website Notes": "Restored",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 101,
    "Condition": "VG",
    "Website Notes": "GI Robot",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 102,
    "Condition": "VG+",
    "Website Notes": "Dino C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 104,
    "Condition": "VG",
    "Website Notes": "Dino C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 105,
    "Condition": "G/VG",
    "Website Notes": "Dino C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Vince"
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 115,
    "Condition": "FN+",
    "Website Notes": "Dino C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 116,
    "Condition": "G/VG",
    "Website Notes": "Dino C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 118,
    "Condition": "VG/F",
    "Website Notes": "Dino C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 119,
    "Condition": "F/VF",
    "Website Notes": "Dino C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 121,
    "Condition": "VG/F",
    "Website Notes": "Dino C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 124,
    "Condition": "VG/F",
    "Website Notes": "Dino C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 128,
    "Condition": "VG",
    "Website Notes": "Dino C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 134,
    "Condition": "VF",
    "Website Notes": "Dino C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 134,
    "Condition": "VG+",
    "Website Notes": "Dino C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 135,
    "Condition": "FN",
    "Website Notes": "Dino C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Vince"
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 137,
    "Condition": "VG",
    "Website Notes": "Dino C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Vince"
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 139,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 144,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 151,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 151,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 154,
    "Condition": "VF",
    "Website Notes": "Origin Unk Soldier",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 154,
    "Condition": "VF+",
    "Website Notes": "Origin Unk Soldier",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 154,
    "Condition": "F/VF",
    "Website Notes": "Origin Unk Soldier",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "BCC"
  },
  {
    "Title": "Star Spangled War Stories",
    "Issue #": 154,
    "Condition": "FN+",
    "Website Notes": "Origin Unk Soldier",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Cutler"
  },
  {
    "Title": "Star Trek Annual",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 1985,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 3,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "gilligans"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 6,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 8,
    "Condition": "VG/F",
    "Website Notes": "1st Gorilla",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "gilligans"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 13,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "gilligans"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 14,
    "Condition": "VG/F",
    "Website Notes": "Robot Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "gilligans"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 20,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "gilligans"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 21,
    "Condition": "VG/F",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 285,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 21,
    "Condition": "VG",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 35,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "gilligans"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 49,
    "Condition": "VG",
    "Website Notes": "Last Precode",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 32,
    "": "Indy"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 55,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 57,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "gilligans"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 58,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 62,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 64,
    "Condition": "VG/F",
    "Website Notes": "Gorilla C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Indy"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 74,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Dmitri"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 75,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 76,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": "Indy"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 86,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Brian trade"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 91,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "gilligans"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 93,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Rapid City"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 93,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 94,
    "Condition": "F/VF",
    "Website Notes": "Fisherman Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "house flipper"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 104,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Brian trade"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 110,
    "Condition": "CGC 7.5",
    "Website Notes": "Classic Grey Tone Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": "Tomlinson"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 112,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Rapid City"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 116,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 120,
    "Condition": "GD",
    "Website Notes": "2nd Atomic Knights",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 124,
    "Condition": "FN",
    "Website Notes": "1st Faceless Creature",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 124,
    "Condition": "VG",
    "Website Notes": "1st Faceless Creature",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 180,
    "Condition": "G+",
    "Website Notes": "1st Animal Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "PBA"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 180,
    "Condition": "VG",
    "Website Notes": "1st Animal Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 180,
    "Condition": "FN",
    "Website Notes": "1st Animal Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 180,
    "Condition": "CGC 7.5",
    "Website Notes": "1st Animal Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 184,
    "Condition": "GD",
    "Website Notes": "2nd Animal Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "PBA"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 186,
    "Condition": "FN",
    "Website Notes": "Gorilla Witch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 190,
    "Condition": "VG/F",
    "Website Notes": "1st A-Man in Costume",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 191,
    "Condition": "VG/F",
    "Website Notes": "2nd Enchantress",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 195,
    "Condition": "VG/F",
    "Website Notes": "Animal Man",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 201,
    "Condition": "G/VG",
    "Website Notes": "Animal Man",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "PBA"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 205,
    "Condition": "CGC 8.5",
    "Website Notes": "1st Deadman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 585,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 205,
    "Condition": "CGC 6.5",
    "Website Notes": "1st Deadman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 420,
    "": "Matt"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 205,
    "Condition": "FN-",
    "Website Notes": "1st Deadman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 205,
    "Condition": "VG/F",
    "Website Notes": "1st Deadman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Kent referral"
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 206,
    "Condition": "VF-",
    "Website Notes": "Adams begins",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 207,
    "Condition": "VF+",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 208,
    "Condition": "VG/F",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 208,
    "Condition": "CGC 9.4",
    "Website Notes": "Bethlehem",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 315,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 209,
    "Condition": "VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 210,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 210,
    "Condition": "VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 211,
    "Condition": "VF+",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 212,
    "Condition": "CGC 9.4",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 315,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 212,
    "Condition": "VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 213,
    "Condition": "F/VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 214,
    "Condition": "VF+",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 215,
    "Condition": "V/NM",
    "Website Notes": "Deadman",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 216,
    "Condition": "VF+",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 216,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 217,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Strange Adventures",
    "Issue #": 221,
    "Condition": "F/VF",
    "Website Notes": "Adam Strange",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Strange Sports",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Sugar and Spike",
    "Issue #": 10,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Suicide Squad (1987)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Millenium Edition",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 31,
    "Condition": "VG-",
    "Website Notes": "precode",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "gilligans"
  },
  {
    "Title": "Superboy",
    "Issue #": 66,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 68,
    "Condition": "VG",
    "Website Notes": "1st Bizarro",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 68,
    "Condition": "CGC 4.5",
    "Website Notes": "1st Bizarro",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 650,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 68,
    "Condition": "CGC 6.0",
    "Website Notes": "1st Bizarro",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1100,
    "": "Holder"
  },
  {
    "Title": "Superboy",
    "Issue #": 68,
    "Condition": "FN+",
    "Website Notes": "1st Bizarro",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1000,
    "": "House Flipper"
  },
  {
    "Title": "Superboy",
    "Issue #": 76,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 89,
    "Condition": "CBCS 7.0",
    "Website Notes": "1st Mon El",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 325,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 89,
    "Condition": "VG/F",
    "Website Notes": "1st Mon El",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 89,
    "Condition": "G/VG",
    "Website Notes": "1st Mon El",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 100,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 127,
    "Condition": "VG/F",
    "Website Notes": "Intro Bee-Boy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 19,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 171,
    "Condition": "VF",
    "Website Notes": "1st Aquaboy",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 174,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 179,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 185,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superboy",
    "Issue #": 202,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Super DC Giant",
    "Issue #": "S-17",
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 105,
    "": ""
  },
  {
    "Title": "Super Friends",
    "Issue #": 41,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Supergirl",
    "Issue #": 3,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Supergirl",
    "Issue #": 5,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Supergirl",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "Zatanna Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": ""
  },
  {
    "Title": "Supergirl",
    "Issue #": 9,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Supergirl",
    "Issue #": 10,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Supergirl (1996)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Supergirl (2005)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 51,
    "Condition": "VG",
    "Website Notes": "CFL Lois Lane Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Gilligans"
  },
  {
    "Title": "Superman",
    "Issue #": 67,
    "Condition": "GD-",
    "Website Notes": "Perry Como",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "PBA"
  },
  {
    "Title": "Superman",
    "Issue #": 70,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "PBA"
  },
  {
    "Title": "Superman",
    "Issue #": 73,
    "Condition": "G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 76,
    "Condition": "NM",
    "Website Notes": "Millenium Edition",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 81,
    "Condition": "VG",
    "Website Notes": "Superwoman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 110,
    "": "Poon"
  },
  {
    "Title": "Superman",
    "Issue #": 89,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 91,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 91,
    "Condition": "G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": 70,
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 101,
    "Condition": "G+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Dahlgren"
  },
  {
    "Title": "Superman",
    "Issue #": 109,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 109,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 113,
    "Condition": "VF/NM",
    "Website Notes": "Pizza Hut Giveaway",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 122,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": 100,
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 123,
    "Condition": "CBCS 4.0",
    "Website Notes": "Supergirl Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 123,
    "Condition": "CGC 3.5",
    "Website Notes": "Supergirl Proto",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 123,
    "Condition": "CGC .5",
    "Website Notes": "3/4 Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 127,
    "Condition": "FN+",
    "Website Notes": "Titano",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 129,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": 125,
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 135,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": 80,
    "Cost Basis": 60,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 149,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 150,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 153,
    "Condition": "CGC 9.2",
    "Website Notes": "White Pages",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "Tommy"
  },
  {
    "Title": "Superman",
    "Issue #": 155,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 156,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 160,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Green Valley"
  },
  {
    "Title": "Superman",
    "Issue #": 167,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 167,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 175,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 177,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 182,
    "Condition": "CGC 7.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Nick"
  },
  {
    "Title": "Superman",
    "Issue #": 190,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Matt"
  },
  {
    "Title": "Superman",
    "Issue #": 199,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": 200,
    "Cost Basis": 180,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 200,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 212,
    "Condition": "VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 215,
    "Condition": "VG/F",
    "Website Notes": "Adams Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Dahlgren"
  },
  {
    "Title": "Superman",
    "Issue #": 222,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 233,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 233,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 233,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 233,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": 200,
    "Cost Basis": 180,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 233,
    "Condition": "NM",
    "Website Notes": "Millenium Edition",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 233,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 234,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 235,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 239,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 240,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 243,
    "Condition": "CGC 9.6",
    "Website Notes": "Adams Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 315,
    "": "Lone Star"
  },
  {
    "Title": "Superman",
    "Issue #": 245,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 246,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 251,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 252,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 254,
    "Condition": "VF/NM",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 254,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 268,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 272,
    "Condition": "F/VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 278,
    "Condition": "VF/NM",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 284,
    "Condition": "F/VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 300,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 307,
    "Condition": "VF/NM",
    "Website Notes": "Adams Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman",
    "Issue #": 423,
    "Condition": "NM-",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Adventures of Superman",
    "Issue #": 500,
    "Condition": "NM",
    "Website Notes": "Bagged/Sealed",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Superman (1987)",
    "Issue #": 18,
    "Condition": "NM+",
    "Website Notes": "Doomsday",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Superman (1987)",
    "Issue #": 75,
    "Condition": "NM",
    "Website Notes": "Platinum Sealed",
    "Personal Notes (Not on website)": 225,
    "Cost Basis": 200,
    "": ""
  },
  {
    "Title": "Superman (1987)",
    "Issue #": 75,
    "Condition": "NM",
    "Website Notes": "Regular Sealed",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Superman (2005)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Superman Annual",
    "Issue #": 4,
    "Condition": "FN",
    "Website Notes": "11th Legion App",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Superman Annual",
    "Issue #": 11,
    "Condition": "FN+",
    "Website Notes": "Moore/Gibbons",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Dahlgren"
  },
  {
    "Title": "Superman/Batman",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Superman/Batman",
    "Issue #": 8,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Superman/Batman",
    "Issue #": 19,
    "Condition": "NM",
    "Website Notes": "H. Quinn",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Superman Family",
    "Issue #": 164,
    "Condition": "NM-",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Superman Family",
    "Issue #": 169,
    "Condition": "VG/F",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Superman Family",
    "Issue #": 175,
    "Condition": "VF/NM",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Superman's Girlfriend Lois Lane",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1500,
    "": "House Flipper"
  },
  {
    "Title": "Superman's Girlfriend Lois Lane",
    "Issue #": 70,
    "Condition": "CGC 9.6",
    "Website Notes": "1st SA Catwoman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 4000,
    "": "Comiclink"
  },
  {
    "Title": "Superman's Girlfriend Lois Lane",
    "Issue #": 70,
    "Condition": "GD",
    "Website Notes": "1st SA Catwoman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Kent ref"
  },
  {
    "Title": "Superman's Girlfriend Lois Lane",
    "Issue #": 90,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Superman's Girlfriend Lois Lane",
    "Issue #": 103,
    "Condition": "VF+",
    "Website Notes": "Devil c",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Superman's Girlfriend Lois Lane",
    "Issue #": 105,
    "Condition": "VF+",
    "Website Notes": "1st Rose & Thorn",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Superman's Girlfriend Lois Lane",
    "Issue #": 105,
    "Condition": "FN",
    "Website Notes": "1st Rose & Thorn",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Superman's Girlfriend Lois Lane",
    "Issue #": 105,
    "Condition": "VG/F",
    "Website Notes": "1st Rose & Thorn",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Ann Arbor"
  },
  {
    "Title": "Superman's Girlfriend Lois Lane",
    "Issue #": 106,
    "Condition": "F/VF",
    "Website Notes": "I am Curious Black",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 135,
    "": "Kent ref"
  },
  {
    "Title": "Superman's Girlfriend Lois Lane",
    "Issue #": 120,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Superman's Girlfriend Lois Lane",
    "Issue #": 137,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Superman's Pal Jimmy Olsen",
    "Issue #": 10,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Dahlgren"
  },
  {
    "Title": "Superman's Pal Jimmy Olsen",
    "Issue #": 109,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Superman's Pal Jimmy Olsen",
    "Issue #": 134,
    "Condition": "VF-",
    "Website Notes": "1st Darkseid",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "tim"
  },
  {
    "Title": "Superman's Pal Jimmy Olsen",
    "Issue #": 134,
    "Condition": "F/VF",
    "Website Notes": "1st Darkseid",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "Kent ref"
  },
  {
    "Title": "Superman's Pal Jimmy Olsen",
    "Issue #": 134,
    "Condition": "VG+",
    "Website Notes": "1st Darkseid",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Joe"
  },
  {
    "Title": "Superman's Pal Jimmy Olsen",
    "Issue #": 137,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Superman's Pal Jimmy Olsen",
    "Issue #": 138,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Superman's Pal Jimmy Olsen",
    "Issue #": 139,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Superman's Pal Jimmy Olsen",
    "Issue #": 142,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Super Powers (1985)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Super-Team Family",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Super-Team Family",
    "Issue #": 6,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Swamp Thing",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Mark"
  },
  {
    "Title": "Swamp Thing",
    "Issue #": 2,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Swamp Thing",
    "Issue #": 7,
    "Condition": "VF+",
    "Website Notes": "Batman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Mark"
  },
  {
    "Title": "Swamp Thing",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Swamp Thing",
    "Issue #": 9,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Swamp Thing",
    "Issue #": 10,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Swamp Thing",
    "Issue #": 15,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Swamp Thing",
    "Issue #": 21,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Swamp Thing",
    "Issue #": 23,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Swamp Thing",
    "Issue #": 24,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Swamp Thing",
    "Issue #": 37,
    "Condition": "CGC 9.4",
    "Website Notes": "1st John Constatine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 260,
    "": "comiclink"
  },
  {
    "Title": "Swamp Thing",
    "Issue #": 37,
    "Condition": "VF/NM",
    "Website Notes": "1st John Constatine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 190,
    "": "green valley"
  },
  {
    "Title": "Swing With Scooter",
    "Issue #": 12,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Swing With Scooter",
    "Issue #": 18,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Swing With Scooter",
    "Issue #": 20,
    "Condition": "F/VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Swing With Scooter",
    "Issue #": 21,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Swing With Scooter",
    "Issue #": 21,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Swing With Scooter",
    "Issue #": 23,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Swing With Scooter",
    "Issue #": 28,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Swing With Scooter",
    "Issue #": 29,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Sword of Sorcery",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tales of the Teen itans",
    "Issue #": "1-4",
    "Condition": "FN/VF",
    "Website Notes": "set",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tales of the Teen itans",
    "Issue #": 44,
    "Condition": "F/VF",
    "Website Notes": "Origin Deathstroke",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Tales of the Ghost Castle",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 9,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Indy"
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 10,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Indy"
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 23,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 44,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Taylor"
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 75,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 76,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "PBA"
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 78,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "PBA"
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 80,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "PBA"
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 81,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "PBA"
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 87,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "PBA"
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 94,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "PBA"
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 96,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "PBA"
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 99,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "PBA"
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 100,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "PBA"
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 101,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "PBA"
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 102,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "PBA"
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 102,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Tales of the Unexpected",
    "Issue #": 104,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "PBA"
  },
  {
    "Title": "Teen Titans",
    "Issue #": 1,
    "Condition": "CGC 6.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 195,
    "": "comiclink"
  },
  {
    "Title": "Teen Titans",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Teen Titans",
    "Issue #": 3,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Teen Titans",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Teen Titans",
    "Issue #": 5,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Teen Titans",
    "Issue #": 21,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Teen Titans",
    "Issue #": 26,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Teen Titans",
    "Issue #": 27,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Teen Titans",
    "Issue #": 30,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Teen Titans",
    "Issue #": 31,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Teen Titans",
    "Issue #": 38,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Teen Titans",
    "Issue #": 40,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Teen Titans",
    "Issue #": 44,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Teen Titans",
    "Issue #": 48,
    "Condition": "VF",
    "Website Notes": "1st Harlequin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Teen Titans",
    "Issue #": 50,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Three Mouseketeers (1970)",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Three Mouseketeers (1970)",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Three Mouseketeers (1970)",
    "Issue #": 7,
    "Condition": "VG/F",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 1,
    "Condition": "CGC 5.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 435,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 7,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 20,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 60,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": "Green Valley"
  },
  {
    "Title": "Tomahawk",
    "Issue #": 63,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 69,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 73,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 81,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 98,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 117,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 122,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 125,
    "Condition": "VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "BCC"
  },
  {
    "Title": "Tomahawk",
    "Issue #": 131,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 133,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 134,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 134,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 135,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 135,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 135,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Tomahawk",
    "Issue #": 139,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 105,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 109,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 117,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 118,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 123,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 124,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 125,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 128,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 131,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 134,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 136,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 137,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 138,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 140,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 141,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 142,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 144,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 145,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 147,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 148,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Unexpected",
    "Issue #": 159,
    "Condition": "VF+",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Vengeance of Bane",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "1st Bane",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Joe"
  },
  {
    "Title": "Warlord",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Warlord",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Jerrys Friend"
  },
  {
    "Title": "Weird Mystery Tales",
    "Issue #": 3,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Weird Mystery Tales",
    "Issue #": 4,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Weird Mystery Tales",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 1,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 4,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "BCC"
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 6,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 7,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 8,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Big Flea"
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 9,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 11,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 16,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 21,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "calgary"
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 22,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 26,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 31,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 32,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 35,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 37,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "BCC"
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 38,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 48,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "30th Century"
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 49,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 20,
    "": "BCC"
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 53,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "BCC"
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 54,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "BCC"
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 61,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "BCC"
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 64,
    "Condition": "FN",
    "Website Notes": "1st Miller art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 68,
    "Condition": "F/VF",
    "Website Notes": "2nd Miller",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 68,
    "Condition": "VG/F",
    "Website Notes": "2nd Miller",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird War Tales",
    "Issue #": 94,
    "Condition": "VF/NM",
    "Website Notes": "Dinosaur C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "calgary"
  },
  {
    "Title": "Weird Western Tales",
    "Issue #": 14,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird Western Tales",
    "Issue #": 16,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird Western Tales",
    "Issue #": 19,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird Western Tales",
    "Issue #": 21,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird Western Tales",
    "Issue #": 22,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird Western Tales",
    "Issue #": 27,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Western Comics",
    "Issue #": 71,
    "Condition": "VG",
    "Website Notes": "Grey Tone Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "TTreasures"
  },
  {
    "Title": "Witching Hour",
    "Issue #": 1,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 180,
    "": "Mark"
  },
  {
    "Title": "Witching Hour",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Bednarz"
  },
  {
    "Title": "Witching Hour",
    "Issue #": 8,
    "Condition": "NM-",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 60,
    "": "Tommy"
  },
  {
    "Title": "Witching Hour",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "Adams Toth",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 9,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 11,
    "Condition": "VF/NM",
    "Website Notes": "Adams Toth",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Tommy"
  },
  {
    "Title": "Witching Hour",
    "Issue #": 11,
    "Condition": "VF",
    "Website Notes": "Adams Toth",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 11,
    "Condition": "F/VF",
    "Website Notes": "Adams Toth",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 13,
    "Condition": "VF/NM",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 15,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 16,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 17,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 17,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Trade"
  },
  {
    "Title": "Witching Hour",
    "Issue #": 19,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 22,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 24,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 26,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 27,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 28,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 32,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 35,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 38,
    "Condition": "VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 43,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 44,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Palm Beach"
  },
  {
    "Title": "Witching Hour",
    "Issue #": 72,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 76,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 77,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Palm Beach"
  },
  {
    "Title": "Witching Hour",
    "Issue #": 78,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Palm Beach"
  },
  {
    "Title": "Witching Hour",
    "Issue #": 79,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Palm Beach"
  },
  {
    "Title": "Witching Hour",
    "Issue #": 82,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Palm Beach"
  },
  {
    "Title": "Witching Hour",
    "Issue #": 82,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Witching Hour",
    "Issue #": 85,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Palm Beach"
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 52,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 160,
    "": "Lehigh Valley"
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 87,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 180,
    "": "Columbus"
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 107,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 185,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 107,
    "Condition": "CGC 5.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 225,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 131,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 147,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 162,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Dahlgren"
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 166,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 178,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 179,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 192,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 194,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Wonder Woman (1987)",
    "Issue #": 197,
    "Condition": "VF/NM",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 197,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 197,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 201,
    "Condition": "VF+",
    "Website Notes": "Catwoman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 201,
    "Condition": "VF",
    "Website Notes": "Catwoman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 201,
    "Condition": "VF-",
    "Website Notes": "Catwoman",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 203,
    "Condition": "VF",
    "Website Notes": "Bondage Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "2023 BCC"
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 204,
    "Condition": "CGC 7.5",
    "Website Notes": "1st Nubia",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 160,
    "": "comiclink"
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 209,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 211,
    "Condition": "NM-",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "palm springs"
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 218,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 218,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 229,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 232,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 315,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Wonder Woman (1987)",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Wonder Woman (1987)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Wonder Woman (1987)",
    "Issue #": 7,
    "Condition": "NM",
    "Website Notes": "Cheetah",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Wonder Woman",
    "Issue #": 72,
    "Condition": "NM",
    "Website Notes": "Classic Bolland Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "2023 BCC"
  },
  {
    "Title": "Wonder Woman (1987)",
    "Issue #": 89,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Wonder Woman (1987)",
    "Issue #": 95,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Wonder Woman (1987)",
    "Issue #": 148,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Worlds Collide",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Polybagged",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 77,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 90,
    "Condition": "VG",
    "Website Notes": "Batwoman C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 90,
    "": "Fox"
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 97,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Dahlgren"
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 100,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": 50,
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 111,
    "Condition": "VF",
    "Website Notes": "1st Clock King",
    "Personal Notes (Not on website)": 170,
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 116,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": 90,
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 129,
    "Condition": "F/VF",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Dahlgren"
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 129,
    "Condition": "FN+",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 137,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": 90,
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 140,
    "Condition": "F/VF",
    "Website Notes": "Clayface",
    "Personal Notes (Not on website)": 90,
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 141,
    "Condition": "CGC 6.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": "Nick"
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 143,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 147,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 153,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 3,
    "": "Bednarz"
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 156,
    "Condition": "CGC 8.5",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 150,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 156,
    "Condition": "FN",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 156,
    "Condition": "FN+",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 160,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 166,
    "Condition": "VF-",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 166,
    "Condition": "VG",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 169,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 173,
    "Condition": "CGC 8.5",
    "Website Notes": "Two Face",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 173,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 175,
    "Condition": "VF",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 176,
    "Condition": "CGC 8.0",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Calgary"
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 177,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 177,
    "Condition": "VF+",
    "Website Notes": "Joker c/s",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 188,
    "Condition": "NM-",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 198,
    "Condition": "VG/F",
    "Website Notes": "Sup/Flash race",
    "Personal Notes (Not on website)": "3 avail",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 199,
    "Condition": "FN+",
    "Website Notes": "Sup/Flash race",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 199,
    "Condition": "VG/F",
    "Website Notes": "Sup/Flash race",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 199,
    "Condition": "F/VF",
    "Website Notes": "Sup/Flash race",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 204,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 215,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Worlds Finest",
    "Issue #": 232,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Young Love",
    "Issue #": 69,
    "Condition": "FN",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "Romance",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Young Love",
    "Issue #": 69,
    "Condition": "VG",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "Romance",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Young Love",
    "Issue #": 81,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Romance",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Young Romance",
    "Issue #": 153,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Romance",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Young Romance",
    "Issue #": 198,
    "Condition": "VF",
    "Website Notes": "100 Pg Giant",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  }
];
